module.exports = {
  message: {
    home: "首页",
    ticket: "机票",
    contactUs: "联系我们",
    mySchedule: "我的行程",
    hotel: "酒店",
    login: "登录",
    regist: "注册",
    Enjoyatrip: "享受出行",
    Meetingtheworldandfeelingtheworld: "遇见世界 感受世界",
    traditional: "繁體",
    chinese: "简体中文",
    english: "English",
    fly: "约吗，打着飞的看世界",
    ad: "搜索来自超过一千家航空公司的最合适航班.",
    dot: "国内机票",
    int: "国际机票",
    Theaccountn: "使用此电邮地址并输入密码以建立账户。",
    createAccountForYou: "我们将帮您创建一个账户，以便接收关于行程的信息。",

    oneWay: "单程",
    twoWay: "往返",
    Sincereservicededicatedfeedback: "真诚服务 用心回馈",
    Alleffortsaretosatisfyyou: "一切努力 只为让您更满意",
    manyWay: "多个目的地",
    Addinvoiceinformation: "添加发票信息",
    fromCity: "出发城市",
    Invoicetype: "发票类型",

    Invoicesareraised: "发票抬头",
    Invoiceinformation: "发票信息",
    toCity: "到达城市",
    fromTime: "出发时间",
    toTime: "到达时间",
    returnTime: "返回时间",
    fromTimeAndReturn: "出发时间-返回时间",
    Cityorairport: "城市或机场",
    flightTo: "飞往",
    cabin: "客舱等级及旅客",
    search: "寻找航班",
    passenger: "旅客",
    traveler: "位旅客",
    advancedOptions: "高级选项",
    preferredAirline: "首选航空公司",
    preferred: "首选舱位",
    close: "关闭",
    addAnother: "添加另外一个航班",
    nonStop: "直飞",
    stop_1: "1 次经停",
    stop_2: "2 次经停",
    refundable: "可退款机票",
    adults: "成人",
    adultsNew: "成人（12+）",
    Select: "选择",
    children: "儿童",
    infants: "婴儿",
    adult: "成人",
    child: "儿童",
    childNew: "儿童（2-12）",
    infantsNew: "婴儿（<2）",
    Overtheageofage: "年龄（大于12）",
    Nostoppingflights: "不经过停航班",
    childrenAge: "年龄（2~12）",
    infantsAge: "2岁以内",
    showOptions: "显示选项",
    hideOptions: "隐藏选项",
    seat: "座位等级",
    nonstopFlightsOnly: "直飞",
    refundableFlightsOnly: "仅限可退票航班",
    explain: "价格为单人往返票价，含所有税费，但不含行李费。",
    sortBy: "分类",
    sortFilter: "分类和筛选",
    transit: "经停",
    startingPrice: "出发起价",
    city: "城市",
    airlinesIncluded: "包含的航空公司",
    morning: "上午",
    earlyMorning: "早晨",
    forenoon: "上午",
    afternoon: "下午",
    evening: "晚上",
    select: "选择",
    freeCancellation24: "24小时内免费取消",
    booking_24: "预订24小时以内可以免费取消！",
    itineraryDetail: "航班详情",
    hour: "小时",
    minute: "分钟",
    second: "秒",
    baggageFee: "行李费",
    personalLuggage: "随身行李",
    check_inLuggage: "托运行李",
    myOrder: "我的订单",
    myTicket: "我的机票",
    invoice: "发票管理",
    paymentManagement: "支付管理",
    passwordManagement: "密码管理",
    commonCard: "常用卡",
    passengerManagement: "旅客管理",
    postManagement: "邮寄管理",
    integralManagement: "积分管理",
    clientServiceCenter: "客服中心",
    preferentialCodeManagement: "优惠码管理",
    recommendationsAndObservations: "建议与意见",
    accountBinding: "账号绑定",
    deleteAnOrder: "删除订单",
    detailsQuery: "详情查询",
    fullOrder: "全部订单",
    orderType: "订单类型",
    firmOrder: "有效订单",
    refundOrder: "退款订单",
    orderTime: "订单时间",
    LastMonth: "最近一个月",
    LastThreeMonth: "最近三个月",
    oneYear: "一年",
    from: "起",
    to: "到",
    refundSuccessful: "退款成功",
    ticketSuccessful: "出票成功",
    beingTickets: "正在出票",
    transactionClosure: "交易关闭",
    returnTicket: "退票",
    alterTickets: "改签",
    totalOrders: "订单总额",
    orderNumber: "订单号",
    applyForSuccessful: "退票申请成功",
    refundTo: "出票方退款至我司",
    originalReturn: "退款按原路返还",
    bankActualTime: "（请以银行实际时间为准）",
    refundPerson: "退票人",
    unbookedFlight: "退订航班",
    cancellationCost: "退订费用",
    withdrawalTime: "退订款项成功时间",
    Passenger: "乘机人",
    sex: "性别",
    birthday: "生日",
    nationality: "国籍",
    age: "年龄",
    passport: "护照",
    issueAt: "签发地",
    periodOfValidity: "有效期",
    exchangeShop: "票号",
    toIssueTicket: "出票中...",
    outstandingTicket: "未出票",
    contacts: "联系人",
    phone: "电话",
    phoneExcample: "（例:+852-77776666,输入:77776666）",
    e_mail: "邮件",
    logonMember: "登录会员",
    LoginAccount: "登录账号",
    loginPassword: "登录密码",
    PleaseEnterPhone: "请输入电话号码/邮箱地址",
    PleaseEnterPassword: "请输入登录密码",
    ForgetPassword: "忘记密码?",
    Savestatus: "保存登录状态",
    Logimmediately: "立即登录",
    LogonAs: "登录为",
    Worldline: '"TRIP"',
    AfterUser: "用户后，您可以",
    TravelAgent: "畅游与Trip合作的机票代理商网站，轻松管理订单",
    Queryplan: "查询、计划、管理您的预定信息",
    //ExclusiveSpecial: "会员独家优惠和特价促销",
    thirdPartyLogon: "支持第三方登录",
    register: "注册新会员",
    switch: "切换",
    mailbox: "邮箱",
    PhoneNumber: "电话号码",
    NationalArea: "国家/地区",
    china: "中国",
    Registeredmailbox: "注册邮箱",
    PleaseEnterMailbox: "请输入邮箱地址",
    VerificationCode: "验证码",
    PleaseEnterVerification: "请输入验证码",
    ActivationCode: "激活码",
    PleaseEnteractivationCode: "请输入激活码",
    GetActivationCode: "获取激活码",
    CheckYourTravelPlans: "检查您的旅行计划",
    Great: "好极了！您选择了我们的其中一个最超值航班。",
    BookTicketsNow: "机会不容错过，赶快订票吧！",
    TheMostValue: "最超值",
    ContinueToReserve: "继续预定",
    BookingWithin24Hours: "预订完成 24 小时内，",
    freeCancellation: "可免费取消！",
    SaveTheOrder: "保存该订单",
    ItinerarySummary: "行程摘要",
    flight: "航班",
    Returnflight: "回的航班",
    TaxesAndDues: "税费",
    ReservationFee: "预定费",
    TravelInTotal: "行程总计：",
    ThePriceIsQuotedInDollars: "价格以港币报出",
    ImportantFlightInformation: "重要的航班信息",
    RefundableAirTicket: "机票可退款",
    ChangeTheFlight: "更换航班",
    lockInThePrice: "锁定价格 - 只需几分钟！",
    noPrice: "直至完成预定之前都无法保证价格。",
    after24Hours: "24小時后，",
    followThe: "需遵守标准的机票规定",
    theLogonAccount: "登陆账号可加快预定速度",
    E_mail: "电子邮箱地址",
    login: "登录",
    whoGoingTravel: "谁要去旅行？",
    thePassengerS:
      "旅客姓名必须与政府签发的带有本人照片的证件上所示的完全一致。",
    mainContactPerson: "（主要联系人）",
    name: "名字",
    Eliminate: "清除",
    middleName: "中间名",
    Aflighttothecity: "去的航班",
    familyName: "姓氏",
    dateOfBirth: "出生日期",
    codicePaese: "国家/地区编码",
    receiveSMSalerts:
      "接收关于本次行程的短信提醒。可能会收取短信和数据服务费。",
    frequentFliers: "常旅客等",
    frequentFlyer: "常客计划",
    SchemeNo: "计划编号",
    PleaseSelect: "请选择",
    weWillInform:
      "我们会将计划详细信息告知航空公司，然而无法保证一定获取积分奖励。",
    emergencyContactName: "紧急联系人姓名",
    creditCard: "信用卡",
    CardholderName: "持卡人姓名",
    CCNumber: "信用卡卡号",
    month: "月",
    year: "年",
    Sendverificationcode: "发送验证码",
    safetyCode: "安全码",
    CountryRegion: "国家/地区",
    Sendactivationcode: "发送激活码",
    billingAddress1: "账单地址1",
    billingAddress2: "账单地址2",
    accountmanagement: "账号管理",
    County: "县/省/市/自治区",
    EmailAddressCoding: "邮箱编码",
    whereMail: "我们应该将您的确认邮件发送到哪里？",
    pleaseEnterEmail: "请输入希望接收确认信息的电子邮件地址。",
    createAnaccount: "创建账户 ，不仅付款更快，还能方便地查看行程。",
    useTheAboveEmailAddress: "使用以上电子邮件地址，输入密码创建账户。",
    CreatePassword: "创建密码",
    passwordLimif: "(包含 6 到 30 个字符，不包含空格)",
    confirmPassword: "确认密码",
    determineAndScheduleYourTrip: "确定并预约行程",
    agreeToObey: "我已阅读并同意遵守",
    UniversalServiceAgreement: "Trip 用户服务协议",
    AgreementRegistration: "同意协议并注册",
    retrieveThePassword: "找回密码",
    retrieve: "找回",
    PleaseEterPhoneNumber: "请输入电话号码",
    ClickGetCode: "点击获取验证码",
    nextStep: "下一步",
    emails: "电子邮件",
    resetPassword: "重置密码",
    cipherStrength: "密码强度",
    weak: "弱",
    center: "中",
    strong: "强",
    PleaseEnterAgainPassword: "请再次输入登录密码",
    confirm: "确认",
    userProtocol: "用户协议",
    serviceSupport: "服务支持",
    disclaimer: "网站使用条款",
    privacyPolicy: "隐私政策",
    hongkongWuzhou: "香港五洲国际旅游有限公司",
    JinlunMansion: "香港九龙长沙湾荔枝角道838号历丰中心12楼1201室",
    companyName: "Trip国际旅游（深圳）有限公司",
    companyAddress: "深圳市罗湖区黄贝街道新秀社区沿河北路1002号瑞思大厦A座31楼",
    recordNumber: "粤ICP备2020076261号-5",
    cooperativePartner: "合作伙伴",
    russia: "俄罗斯",
    hotSeason: "当季热门",
    canada: "加拿大",
    newYork: "纽约",
    HongKong: "香港",
    TodayDeal: "今日特价",
    // TodayDeal: "11.11特惠",
    TodayDealMark: "双11期间HKG-BKK/TPE航线全线8折起",
    customerServiceHotline: "客服热线",
    listeningYourVoice: "您的声音我们用心在听",
    ServiceMailbox: "服务邮箱",
    lookEachYourLetters: "认真查看，你们的每一封来信",
    feedback: "意见反馈",
    ProfessionalTeam: "专业解答,您的所有问题",
    ClickSubmission: "点击提交",
    NoviceGuide: "新手上路快速引导",
    becomeMemberQuickly: "还不是会员，如何快速成为会员",
    becomeMember: "如何成為Trip會員",
    thirdPartyAccounts: "如何通过第三方账号登录",
    PayRelatedIssues: "支付相关问题",
    More: "更多",
    Relatedissues: "相关问题",
    AccountRelatedHelp: "账户中心相关帮助",
    BindingCardHelp: "绑卡相关帮助",
    PayRelatedHelp: "支付相关帮助",
    RefundRelatedHelp: "退款相关帮助",
    AirlineTicketRelated: "机票相关",
    buyChildTicket: "如何购买儿童票",

    HowInternationalTicketsPay: "国际机票如何支付票款",
    MembershipService: "会员服务",
    MemberDataManagement: "会员资料管理",
    PasswordCuery: "密码查询",
    MembershipRegistration: "会员注册",
    unsubscribe: "注销账户",
    ClickBindings: "点击绑定",
    ThankYouForUsingIt: "非常感谢您使用",
    welcomeToTellUs:
      "如果您有任何建议，欢迎您来告诉我们,您的意见将帮助我们改进产品和服务",
    AccountNumber: "账号",
    PleaseSelectProduct: "(请选择一个产品分类以帮助我们确认问题)",
    ContactName: "联系姓名",
    Contact: "联系",
    shouji: "手机号码",
    ItCanBeEntered: "还可以输入",
    word: "字",
    content: "内容",
    Submission: "提交",
    PleaseDescribeYourSuggestions:
      "请您尽可能具体的描述您对我们的建议，这将能够更好的帮助我们改进产品和服务",
    ConcessionCode: "优惠码",
    PleaseConcessionCode: "请输入优惠码",
    ConfirmationClaim: "确认领取",
    ConcessionCode: "优惠码明细",
    AmountAvailable: "可用金额",
    element: "(元)",
    AvailableNumber: "可用个数",
    individual: "(个)",
    NoCoupons: "暂无优惠券",
    inUse: "使用中",
    operation: "操作",
    state: "状态",
    balance: "余額",
    Denomination: "面额",
    ExpiryTime: "过期时间",
    ReceiveTime: "领取时间",
    CardNumber: "卡号",
    NameChen: "名称",
    Expired: "已过期",
    haveBeenExhausted: "已用完",
    Available: "可使用",
    whole: "全部",
    enterTheProblems: "输入您所遇到的问题 我们帮您解决",
    HotSearch: "热门搜索",
    purchase: "购买",
    PlaneTicket: "机票",
    InternationalTicket: "国际机票",
    allowanceInternationalRoutes: "请问国际航线免费行李额有哪些规定",
    international: "(国际)",
    twoKindsWeight:
      "国际航线免费行李额分别为计重免费行李额和记件免费行李额两种",
    /*
    FreeBaggageAllowance:"计件免费行李额：按照旅客所付的票价座位等级，" +
      "每一全票或半票旅客免费行李额为两件, 每件的长宽高三边之和不得超过158厘米",
    BecauseEachAirline:"因每条航线及航空公司规定不统一，具体情况以您咨询航空公司和代理商为准",
    inch:"英寸",
    Pound:"镑",
    TheWeightEachPieceShall:"每件重量不得超过32公斤。但持有经济舱(包括旅游折扣)客票的旅客，其两件行李长宽高的总和不得超过273厘米",
    NoFreeBaggageAllowance:"按成人全票价百分之十购买的婴儿无免费行李额",
    accordingToTheFareAndSeat:"计重免费行李额：按照旅客所付的票价座位等级，每一全票或半票旅客免费行李额为：头等舱为40公斤",
    TheBusinessClassIs30Kilos:"公务舱为30公斤",
    EconomyAClass:"经济舱(包括旅游折扣)为20公斤",
    */
    weightFreeBaggageAllowance:
      "计重免费行李额：按照旅客所付的票价座位等级，每一全票或半票旅客免费行李额为：头等舱为40公斤(88镑)，公务舱为30公斤(66镑)，经济舱(包括旅游折扣)为20公斤(44镑)，按成人全票价百分之十购买的婴儿无免费行李额",
    freeBaggageAllowance:
      "计件免费行李额：按照旅客所付的票价座位等级，每一全票或半票旅客免费行李额为两件, 每件的长宽高三边之和不得超过158厘米(62英寸)，每件重量不得超过32公斤。但持有经济舱(包括旅游折扣)客票的旅客，其两件行李长宽高的总和不得超过273厘米(117英寸)，按成人全票价百分之十购买的婴儿无免费行李额",
    BecauseEachAirline:
      "因每条航线及航空公司规定不统一，具体情况以您咨询航空公司和代理商为准",

    MyPoints: "我的积分",
    branch: "分",
    QueryTime: "查询时间",
    TheLastMonth: "最近一个月",
    ThreeMonths: "三个月",
    AYear: "一年",
    ScreeningConditionsEmptying: "清空筛选条件",
    IntegralName: "积分类型",
    GenerationTime: "产生时间",
    income: "操作类型",
    expenditure: "数额",
    abstract: "摘要",
    Remarks: "备注",
    AddMailingAddress: "添加",
    XingMing: "姓名",
    ChineseEnglish: "姓名",
    areaLocated: "所在地区",
    DetailedAddress: "详细地址",
    ZipCode: "邮编",
    CellPhoneNumber: "手机号",
    modify: "修改",
    delete: "删除",
    DeleteInformation: "删除信息",
    EssentialInformation: "基本信息",
    ReturnToTheUserList: "返回用户列表",
    Location: "所在地",
    SelectProvince: "选择省",
    ChooseUrbanArea: "选择市区",
    SelectedAreaCounty: "选择区/县",
    EnterDetailedAddress: "请输入详细地址",
    PostalCode: "邮政编码",
    PleaseEnterZipCode: "请输入邮政编码",
    Preservation: "保存",
    cancel: "取消",
    addressManagement: "邮寄地址管理",
    CommonPassengerManagement: "常用旅客管理",
    AddingCommonlyUsed: "添加常用旅客信息",
    DocumentType: "证件类型",
    IdentificationNumb: "证件号码",
    AirlineCard: "航司卡",
    TypeOfPassenger: "旅客类型",
    MailingAddress: "邮寄地址",
    BasicInformation: "基础信息",
    ReturnListPage: "返回列表页",
    nameMustBeFilled: "中文名字和英文名字必须填一个",
    keepItSafePassword: "登录账户时需要输入登录密码，请妥善保管",
    oldPassword: "当前密码",
    NewPassword: "新密码",
    EnterNewPassword: "输入新密码",
    EnterPassWordAgain: "再次输入密码",
    ConfirmationModification: "确认修改",
    ForgetLoginPassword: "忘记登录密码",
    man: "男",
    woman: "女",
    SystemMessage: "系统消息",
    news: "消息",
    AllMarkedRead: "全部标记为已读",
    strip: "条",
    RefundStatusMessage: "退款状态消息",
    purchaseSuccessful: "您于2018-9-18 00:15购买的深圳-南昌机票订单退款成功",
    ViewTheDetails: "查看詳情",
    ChinaName: "中文名",
    EnglishName: "英文名",
    AddDocuments: "添加其他证件",
    errorMessages: "请更正下面的错误",

    coin: "无特殊要求",
    showNum: "1位成人， 0名儿童",
    showNumFirst: "位成人,",
    showNumLast: "名儿童",
    preferredSeat: "经济舱",

    fromCityIsNotNull: "出发城市不能为空",
    returnCityIsNotNull: "到达城市不能为空",
    fromTimeIsNotNull: "出发时间不能为空",
    returnTimeIsNotNull: "返程时间不能为空",
    returnTimebyFrom: "返程时间不能在出发时间之前",

    searchErrorMessage: "查询失败，请重试",

    areyousure: "确定删除吗？",

    Onlinepayment: "在线付款",
    Paymentsecurityandoptions: "付款安全和选项",
    Refundtimelimit: "退款时限",
    Howtobuyinsurance: "误机？",
    Changeandrefund: "改签和退票",
    Baggageamount: "行李额",
    Passwordmodification: "密碼修改",
    Addnewpassengers: "添加新旅客",
    Howtobuyinsurance: "如何购买保险？",

    logout: "退出",
    cabinName: "舱等",

    Reservations: "预订机票",
    predeterminedPromptOne:
      "请查看您的详细旅行信息，以确保日期和时间正确无误。",
    predeterminedPromptTwo:
      "请检查您的拼写。航班乘客姓名必须与政府签发的带有本人照片的身份证件上所示的完全相符，如果拼写错误造成退款我们将收取一定手续费。",
    predeterminedPromptThree: "查看预订条款：",
    predefinedClauseOne:
      "我们理解您的出行计划有时会发生变更。我们不收取消或变更费用。如果航空公司按照其内部政策规定收取此类费用，则这部分费用将由您承担。",
    predefinedClauseTwo: "机票可以退款。",
    pleaseRead: "请阅读",
    regulationAndCharterContract: "变更和取消手续费规定全文或包机合同",
    period: "。",
    airlinesLimitationClause: "航空公司责任限制方面的重要信息",
    predefinedClauseThree: "价格可能不包含航空公司直接收取的行李费或其他费用。",
    predefinedClauseFour: "出票前不能保证票价不发生变更。",
    predefinedClauseFive:
      "禁止在通过行李中夹带或是随身的方式携带任何危险品登机。",

    readAndAgree: "选择完成该预订即表示，您确认已阅读并接受上述规则和限制、",
    termsAndConditions: "使用条款",
    privacyStatement: "隐私政策",
    tourSuggestion: "政府旅游建议",
    and: "和",
    regulationsMentionedAbove: "",
    Renewyourpassport: "更新护照",
    acceptAndContinue: "完成预定",
    informationSecurely: "我們使用安全傳輸和加密存儲保護您的個人資訊。",
    oneWayTicket: "单程机票",
    roundTripTicket: "往返机票",
    paymentSuccess: "支付成功!",
    toMyTicket: "去我的行程中查看",
    waitPatiently: "目前正在出票，请您耐心等待，我们将在30分钟内短信通知。",

    registerWithMailbox: "切换邮箱注册",
    registerWithPhoneNumber: "切换电话号码注册",
    logoutSuccessful: "注销成功",
    jumpHome: "跳转首页",
    logIn: "请登录",
    accountNotExist: "账号不存在",
    kindlyReminder: "温馨提示：",
    issuedWithin48hours: "预计订单提交24小时内完成出票!",
    expiryDate: "证件有效时间",
    issuingCountry: "证件发行国家/地区",
    airlineName: "航司名",
    airlineCardNumbers: "航司卡号",
    loading: "加载中",
    frequency: "次",
    timeStop: "次经停",
    nonStopFlight: "直飞",
    conversionTimeDifference: "注意：转换时差后得到的时间",
    includingTaxes: "含税费",
    airline: "航司",
    newFightNumbers: "航班号",
    carrier: "实际承运航司",
    fightNumbers: "实际航班号",
    forFree: "免费",
    forFree20kg: "20公斤以内免费",
    stay: "停留",
    estimate: "预计到达时间:",
    //arrive:"到达",
    pricesQuotedHKD: "价格以港币报出",
    logInAsVisitor: "以游客身份登录",
    passwordChangedSuccessfully: "密码修改成功",
    logInWithNewPassword: "您已成功设置密码，请试用新密码登陆",
    emailUnregistered: "邮箱未注册",
    phoneNumberUnregistered: "手机号码未注册",
    unregistered: "未注册",
    phoneNumberError: "手机号格式错误",
    phoneNumberCannotEmpty: "手机号不能为空",
    emailError: "邮箱格式错误",
    emailCannotEmpty: "邮箱不能为空",
    passwordConfirmError: "两次密码输入不一致，请重新输入",

    firstNameCannotEmpty: "请只使用拼音输入名字",
    middleNameCannotEmpty: "请使用拼音输入中间名",
    lastNameCannotEmpty: "请只使用拼音输入姓氏",
    selectSex: "请选择性别",
    selectCountry: "请选择国籍",
    selectBirthday: "请选择有效的出生日期",
    ageCannotEmpty: "请输入正确的年龄",
    selectCredentialsType: "请选择证件类型",
    passportCannotEmpty: "请输入有效的证件号码",
    selectCardExpired: "请选择证件有效时间",
    selectCardIssuePlace: "请选择证件发行国家",
    selectMobilePrefix: "请选择国家/地区编码",
    selectRegPhoneZone: "请选择国家/地区",

    firstClass: "头等舱",
    businessClass: "商务舱",
    premiumEconomyClass: "高端经济舱",
    economyClass: "经济舱",
    determine: "确定",
    //免责申明
    disclaimerDetails:
      "此网站上公布的信息、软件、产品及服务可能存在误差或错误，包括价格错误。特别要指出的是,Trip公司以及Trip合作伙伴不保证本网站上显示的航班及其他旅行产品和服务的信息和描述（包括但不限于定价、照片、一般产品描述等）的正确性，也不对与此类信息和描述相关的任何错误或其他误差承担任何责任。此外，Trip 明确保留纠正我们网站上的任何定价错误和/或按照错误价格进行的预订的权利。在此类情况下，如果没房，则我们将为您提供按正确价格保留您预订的机会，否则我们将取消您的预订且免收因此产生的罚金。\n" +
      "        Trip公司、Trip合作伙伴及其各自的供应商不对本网站上所包含的信息、软件、产品和服务针对任何目的的适用性做任何声明；在本网站上包含或提供任何产品或服务不构成 Trip 公司或 Trip 合作伙伴对此类产品或服务作出的任何认可或推荐。所有此类信息、软件、产品及服务均“按原样”提供，不含有任何保证。Trip 公司、Trip 合作伙伴及其各自的供应商拒绝承认任何担保及条件，即本网站、网站服务器或 Trip 公司、Trip 合作伙伴和/或其各自的供应商所发送的任何电子邮件不含病毒或其他有害组件。Trip 公司、Trip 合作伙伴及其各自的供应商在此拒绝承认与此信息、软件、产品和服务有关的所有担保及条件，包括所有对适销性、特定用途适用性、产权和非侵权性的默示担保及条件。\n" +
      "        在本网站上提供旅行服务或其他服务的承运商及其他供应商为独立的立约方，并非 Trip 公司或 Trip 合作伙伴的代理或员工。Trip 公司和 Trip 合作伙伴不对任何此类供应商的行为、错误、失职、声明、担保、违规或疏忽负责，也不对由此造成的任何人身伤害、死亡、财产损害或由此产生的其他损害或费用负责。如果发生延迟、取消、过量预订、罢工、不可抗力或其他超出直接控制范围之事由，Trip 公司和 Trip 合作伙伴不承担任何责任且不予退款，并且不对任何额外费用、失职、延迟、重新安排路线或任何政府或机构的行为负责。\n" +
      "        对于您访问、展示或使用本网站引起或与此相关，或与延迟或无法访问、展示或使用本网站相关的任何直接、间接、惩罚性、附带性、特殊或后果性损害赔偿（包括但不限于您对本网站上的观点的依赖；任何计算机病毒、信息、软件、链接的网站、通过本网站获取的产品和服务；或由访问、展示或使用本网站引起），Trip 公司、Trip 合作伙伴和/或其各自的供应商在任何情况下均不承担责任，不论是基于过失论、合约、侵权、严格责任、消费者保护法或其他，且即使在 Trip 公司、Trip 合作伙伴和/或其各自的供应商已被告知该类损害赔偿的可能性的情况下也是如此。\n" +
      "        尽管有以上规定，但如果 Trip 公司、Trip 合作伙伴或其各自的供应商被认定对由任何上述情形引起或与之相关的任何损失或损害负有责任，则 Trip 公司、Trip 合作伙伴和/或其各自的供应商的责任在任何情况下总计不得高于以下费用中的较高者：(a) 您为本网站上的此类交易向 Trip 支付的服务费用，或 (b) 一百美元 (US$100.00) 或以当地货币计算的等值金额。\n" +
      "        责任限制反映了双方之间的风险分配。如果本使用条款所述的任何有限补救未能达到其基本目的，本节所述限制将继续有效并适用。本使用条款规定的责任限制有利于 Trip 公司、Trip 合作伙伴和/或其各自的供应商。",

    privacyPolicyOne: "Trip隐私政策",
    privacyPolicyTwo:
      "下文是Trip更新后的隐私政策。 我们非常重视您对我们的信任，并将确保您提供给我们的个人信息的安全性和机密性作为工作的重中之重。 请阅读此政策，了解我们的隐私保护做法。 访问本网站即表示您接受此处描述的做法。",
    privacyPolicyQ1: "我们收集您的哪些信息",
    privacyPolicyQ2: "我们如何使用您的信息",
    privacyPolicyQ3: "我们与谁共享您的信息",
    privacyPolicyQ4: "您如何访问自己的信息",
    privacyPolicyQ5: "您在您的信息受到收集和使用方面有何选择",
    privacyPolicyQ6: "Cookie 和其他技术",
    privacyPolicyQ7: "显示定制广告/您的选择",
    privacyPolicyQ8:
      "使用 Trip 手机和平板电脑应用（以下简称“移动应用”）",
    privacyPolicyQ9: "我们如何保护您的信息",
    privacyPolicyQ10: "儿童的隐私",
    privacyPolicyQ11: "外部链接",
    privacyPolicyQ12: "对本隐私政策的变更",
    privacyPolicyQ13: "您如何联系我们",
    privacyPolicyAnswer1_1:
      "一般信息。 我们会收到并存储您在我们网站上输入的或者以其他任何方式提供给我们的所有信息。 这包括能够识别您身份的信息（以下简称“个人信息”），包括您的姓氏和名字、电话号码、邮寄地址、电子邮件地址，以及付款信息（如信用卡卡号、持卡人姓名和到期日期）。 您可以选择不向我们提供信息，但是您通常需要提供一些个人信息才能注册为会员、预订旅行、填写旅客资料，参加调查、比赛或抽奖，向我们提问，或者在我们的网站开展其他交易。",
    privacyPolicyAnswer1_2:
      "旅伴信息。 如果您通过本网站为其他人预订，我们将要求您提供该旅客的个人信息和旅行偏好。 您向我们提供该旅客的个人信息和旅行偏好之前，应先征得其本人的同意，这是因为只能通过您的账户查看或更改其信息。",
    privacyPolicyAnswer1_3:
      "从其他来源获得的信息。 我们也会定期从关联实体、业务合作伙伴和其他独立第三方来源获得您的个人信息和非个人信息，并将这些信息添加到我们的账户信息中。 我们可能收到的信息包括：最新的配送和地址信息、购买历史记录和人口统计信息。 此外，如果您使用自己的社交媒体账户注册 Trip 账户关联至社交媒体账户，或者使用某些其它 Trip Trip 的社交媒体功能，我们可能会依照此类社交媒体提供商的政策访问您的信息。 这些信息可能包括您的姓名、电子邮件地址、个人资料照片、性别、朋友列表，以及您授权我们接收的其它信息。 依据您和您朋友的隐私设置，我们可能会访问您提供给社交媒体提供商的各自位置信息（以下简称“位置数据”），以便为您提供相关内容。 请注意，依据您在此类社交媒体提供商的隐私设置，您的位置数据也可能会在社交媒体提供商中与您的朋友共享。",
    privacyPolicyAnswer1_4:
      "自动收集信息。 当您访问本网站时，我们会自动收集有关有关您的计算机的一些信息。 例如，我们会收集您的 IP 地址、Web 浏览器软件（如 Firefox、 Safari 或 Internet Explorer）以及推介网站。 我们还可能会收集有关您的在线活动的信息，如查看的旅行和进行的预订。 我们自动收集这些信息的目的是帮助定制您的用户体验和避免欺诈。",
    privacyPolicyAnswer1_5: "要了解更多信息，请参阅 Cookie 和其它技术。",
    privacyPolicyAnswer2_1:
      "我们使用敏感的付款信息（如持卡人姓名、信用卡卡号和到期日期）以便完成您在我们网站上进行的旅行预订。 我们将您的其它信息用于下述一般目的：向您提供您申请的产品和服务；向您提供旅行确认和更新；管理您的账户，包括处理账单和提供旅行通知；与您进行一般性沟通；答复您的疑问和评论；衡量兴趣度以及改善我们的产品、服务和网站；通知您可能感兴趣的特价以及产品或服务；在其它方面自定您在本网站的体验；在您选择参加的任何奖励和认同计划中作为一部分给您的奖励；从您那里征求信息，包括通过调查的方式；解决争议、收取费用或解决问题；防范潜在禁止的或非法的活动；实施我们的使用条款；以及收集信息时向您描述的其它目的。",
    privacyPolicyAnswer2_2:
      "电子邮件通信。 我们希望您能够轻松地利用我们网站上提供的旅行相关机会。 为此，我们采取的其中一种方法是向您发送电子邮件，在邮件中为您提供您会明显感兴趣的旅行相关信息。 例如，如果您在我们网站上搜索前往纽约的航班，并保存了您的行程或者尚未预订旅行，那么我们会向您发送电子邮件，提醒您已保存的行程或前往纽约的优惠机票。 同样，如果您在收到有关纽约旅行的电子邮件后，告知您可通过我们网站获得与旅行相关的特价产品。 请注意，在我们发送的任何此类电子邮件中，您都有机会选择不接收这些电子邮件。请查阅下方的“您在信息收集和使用方面的选择”。",
    privacyPolicyAnswer3One: "本网站可能会将您的信息与下述实体共享:",
    privacyPolicyAnswer3Two:
      "供应商，即您提供旅行预订项目的供应商，如航空公司和活动提供商。 在本网站，所有由第三方供应商提供的服务都如实描述。 通过本网站预订即表示您授权我们向供应商披露所需的信息，以便完成预订和提供相关旅行。 这些供应商不受 Trip 的控制，向他们披露的个人信息受相应供应商的适用隐私政策和安全保护做法的约束。 因此，如果您通过本网站购买任何旅行供应商的产品，我们建议您查看其隐私政策。",
    privacyPolicyAnswer3Three:
      "第三方供应商，即代表我们提供服务或职能的供应商，包括信用卡处理、业务分析、客户服务、营销、分发调查或抽奖计划，以及预防欺诈。 我们也可能授权第三方供应商代表我们收集信息，包括用于运作我们网站的功能或者便于交付根据您的兴趣定制的在线广告所必需的信息。 第三方供应商只能根据履行职能所需访问信息和收集信息，不得出于任何其他目的共享或使用信息。 他们还需遵循我们所遵守的相同数据安全保护做法。",
    privacyPolicyAnswer3Four:
      "业务合作伙伴，我们可能与他们联合提供产品或服务，也可能在我们的网站提供他们的产品或服务。 当第三方参与提供您所请求的产品或服务时，您会看到他们的名称单独显示，或者与我们的名称一起显示。 如果您选择访问这些可选服务，我们可能会与这些合作伙伴分享您的信息，包括您的个人信息。 需要注意的是，我们无法控制这些第三方业务合作伙伴的隐私保护做法。",
    privacyPolicyAnswer3Five:
      "推介网站。 如果您是经其他网站推荐后访问本网站的（例如，通过点击其它网站的链接直接转至本网站），我们可能与该推介网站共享您的部分信息。 我们尚未对推介网站使用您的个人信息做出任何限制，因此我们鼓励您查看推荐您访问本站的任何推介网站的隐私政策。",
    privacyPolicyAnswer4:
      "如需访问和更新您的联系信息，请访问本网站的“个人信息”页面。 如需注销账户，请按下述电子邮件地址向我们发送电子邮件。 请注意，在注销账户后，您将无法登录或访问您的任何个人信息。 不过，您可以随时新开账户。 另请注意，我们可能会将您的账户的某些关联信息保留一段时间，用于分析以及保持记录完整性等目的。",
    privacyPolicyAnswer5:
      "如上所述，您可以选择不向我们提供任何信息，尽管可能需要这些信息以预订旅行或使用本站提供的某些功能。\n" +
      "您也可以如上文所述添加或更新信息，并可以注销账户。\n" +
      "您将有机会在我们发送的任何信息中从商业电子邮件选择取消订阅。 如果您是注册会员，您还可以随时在“个人信息”页面修改您的选择。 请注意，我们保留向您发送其他通信的权利（包括与您的账户或您在本站的交易相关的服务通知、管理信息及调查），并且不给予您拒收这些通信的机会。\n" +
      "您有机会在我们的网站上提供手机号码，以便接收旅行当日航班提醒。 您随时都可以中止这些提醒。\n" +
      "在大多数浏览器中，工具栏的“帮助”部分都会告诉您如何阻止浏览器接受新的 Cookie，如何设置浏览器以便在收到新 Cookie 时发出通知，或者如何完全禁用 Cookie。 请注意，如果您拒绝接受本站发送的 Cookie，则将无法访问我们网站上的某些内容。",

    privacyPolicyAnswer6One:
      "Cookie 是小的数据文本文件，可以存储在您计算机的硬件驱动器中（如果您的网页浏览器允许）。 本网站的 Cookie 用于以下一般目的：",
    privacyPolicyAnswer6Two:
      "为了帮助我们识别出您的浏览器为此前的访问者，请保存并记住您的浏览器访问我们网站时曾设置的任何偏好。 举例来说，如果您在我们的网站注册，则我们会用 Cookie 记住您的注册信息，这样您每次访问我们网站时就不需要登录。 如果您勾选了“Sign me in automatically next time”（下次自动登录）复选框，我们还可能在 Cookie 中记录您的密码。 请注意，出于安全目的，此类 Cookie 中所包含的会员 ID、密码以及任何其它账户相关数据都是加密的。 除非您在我们这里注册，否则这些 Cookie 中将不会包含任何个人信息。",
    privacyPolicyAnswer6Three:
      "目的是为了帮助我们定制本网站和互联网其它网站提供给您的内容和广告。 例如，当您访问我们的网站时，我们、我们的服务提供商或者我们的合作方会自动创建 cookie，以便您在互联网上浏览时识别您的浏览器，根据您表现出的偏好向您推送信息和广告。 如欲详细了解我们的在线广告做法和您的选择，请参阅广告显示/您的选择。",
    privacyPolicyAnswer6Four:
      "目的是为了帮助我们衡量和研究网站功能以及产品、服务、广告和电子邮件通信（通过确定您打开了哪些电子邮件并做出行动）的有效性。",
    privacyPolicyAnswer6Five:
      "在大多数浏览器中，工具栏的“帮助”部分都会告诉您如何阻止浏览器接受新的 Cookie，如何设置浏览器以便在收到新 Cookie 时发出通知，或者如何完全禁用 Cookie。 请注意，如果您拒绝接受 Cookie，则可能无法访问我们网站提供的许多旅行工具。",
    privacyPolicyAnswer6Six:
      '除了上述 Cookie 之外，我们还在网站上使用本地共享对象（也称作 "Flash Cookie"）。 它们通过存储您的用户首选项和设置（如您的音量/静音设置），并关联我们网站上的动画内容，力求改善您的用户体验。 本地共享对象与浏览器 Cookie 相似，但可以存储比简单文本更复杂的数据。 它们自己无法对您的计算机上的数据执行任何操作。 与其他 Cookie 一样，它们只能访问您在本网站上提供的个人身份识别信息，而且其他网站无法访问它们。 如欲了解有关 Flash Cookie 的更多信息或者其禁用方法，请访问： http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html.本网站还可能使用 Web 信标（也称作透明 GIF、像素标签或网络爬虫），它们是放置在网页代码中带有唯一标识符的微小图形，功能与 Cookie 类似。 我们使用 Web 信标监控用户从我们网站内的一个页面转到另一个页面的流量模式，使用 Cookie 提供内容或进行通信，了解您是否从第三方网站显示的在线广告转到我们网站，以及增强网站性能。 我们还可能允许服务提供商使用 Web 信标，以帮助我们了解收件人打开过哪些电子邮件并跟踪我们网站上的访客流量和操作。 这有助于我们衡量我们的内容和其他产品的效力。',
    privacyPolicyAnswer6Seven:
      "如果您对我们的 Cookie 或其他技术的用途有任何疑问，请通过电子邮件向我们发送客户服务和反馈表。",

    privacyPolicyAnswer7_1:
      "本网站利用所收集的数据向您提供相关广告。 Trip 致力于为您提供相关内容和信息。 为此，我们可能会通过 Cookie 和其它技术 收集您的旅游相关搜索信息，比如您是否查找航空公司航线。 我们利用这一信息，连同我们收集的您的其它相关信息，在我们的网站或者网上其它地方为您推送与您的兴趣相匹配的广告。 因此举例来说，如果您在本站搜索前往佛罗里达的航班，则您可能在本站或者访问的其它网站上看到佛罗里达旅行套餐的广告。\n" +
      "请注意，我们不会把收集的您在本网站查找到的旅行相关搜索结果与您的个人信息（如电子邮件地址）相结合，以便在其它网站推送广告。 我们也不会与第三方共享您的个人信息，以便它们推送广告。 您可以在其它网站上选择不接收根据您在本网站进行的旅行相关搜索而定制的在线广告。 请注意，如果您选择不接收定制广告，您仍将看到在线广告，只是它们将更一般化且与您的关联更少。业务合作伙伴和广告网络利用所收集的数据向您提供相关广告。",
    privacyPolicyAnswer7_2:
      "您在本网站看到的广告是由我们或我们的服务提供商提供的。 不过，我们也允许第三方通过 Cookie 和其他技术收集您的在线活动相关信息。 这些第三方包括 (1) 业务合作伙伴（当您查看他们投放在我们网站的某个广告或与该广告交互时，他们会收集信息）；以及 (2) 广告网络（当您查看他们投放在 Internet 的很多不同网站上的某个广告或与该广告交互时，他们会收集有关您的兴趣的信息）。 这些第三方收集的信息用于预测您的性格、兴趣或偏好，以及在我们的网站及互联网上根据您显露的兴趣展示定制广告。 我们不允许第三方在我们的网站收集您的个人信息（如电子邮件地址），也不会与他们共享您的任何个人信息。",
    privacyPolicyAnswer7_3:
      "请注意，我们无法访问或控制这些第三方在收集有关您的兴趣信息时可能会使用的 Cookie 或其他技术，也无法访问或控制不属于本隐私政策范围的第三方信息处理做法。 这些公司中有一些是网络广告促进协会的会员，这个机构为人们提供了可以选择不接受会员公司广告的机会。“请勿跟踪”信号和类似机制。 一些网络浏览器可能会向与浏览器通信的网站传输“请勿跟踪”信号。 由于网络浏览器整合和激活这一功能的方法存在差异，因此有时我们并不清楚用户是否有意传送这些信号，或者是否意识到它们存在。 领先的互联网标准设置组织的参与者正在解决这一问题，他们正在确定接收到此类信号时哪些（如果有）网站应这样做。 目前，Trip 不会对这些信号做出应对行动。 如果有最终标准，并且最终标准已确立并被广泛接受时，我们将重新评估应如何应对这些信号。",
    privacyPolicyAnswer8:
      "当您使用 Trip Trip移动应用时，我们会像您在使用我们的网站时一样，以相同的方式并出于相同的目的收集和使用您的信息。\n" +
      "除此之外，我们还会使用我们在您使用我们的移动应用时自动收集的某些其他信息。 具体来说：\n" +
      "我们会收集您访问和使用的移动应用功能的信息。 通过这些信息，我们可确定客户对移动应用的哪些部分感兴趣，进而能完善和不断改善移动应用。 但是，我们无法通过出于此目的而收集的信息直接识别您的身份。\n" +
      "每个移动应用也会向我们发送设备的唯一设备标识符（即“UID”），该标识符由一串数字或字符组成，对您的移动设备具有唯一性。 我们仅在客户首次打开移动应用时使用此标识符，以便我们能够向我们的广告网络确认单击他们的相应广告横幅和其他营销工具所带来的下载量。\n" +
      "使用移动应用时，您可以选择允许移动应用访问您的当前位置（此位置由移动设备利用 GPS 或类似技术提供），以便发现附近的机场。 如果选择允许移动应用访问当前位置，此位置数据可能会以匿名形式收集，并作为我们的服务器记录的搜索请求的一部分。 您可以随时通过手机设置菜单，关闭移动应用对您所处位置的访问。\n" +
      "每个移动应用也会在崩溃或挂起时向我们发送错误报告信息。 此类信息有助于我们调查错误原因，并改善未来发布的移动应用的稳定性。 移动应用向我们发送的这些错误报告中包括移动设备类型和版本、UID、错误发生时间、错误发生时正在使用的功能以及应用程序状态的信息。 除了调查并修复错误外，我们不会将此信息用于任何其他目的。\n" +
      "您始终能控制移动应用向我们发送的信息的内容。 为此，您可以更改移动应用设置菜单下的设置或更改移动设备的设置。 此外，您也可以从移动设备中完全删除移动应用，并通过我们的网站访问我们的服务。",
    privacyPolicyAnswer9:
      "我们希望您能放心地使用本网站安排旅行，为此，我们将竭力保护所收集的信息。 虽然没有哪一家网站能够保证绝对的安全，但是我们实施了恰当的管理、技术和物理安全程序，有助于保护您提供给我们的个人信息。 例如，我们仅允许获得授权的员工访问个人信息，并且他们只会在履行职责时访问个人信息。 此外，我们在您的系统和我们的系统之间传输您的敏感个人信息时会使用加密技术。我们还使用防火墙和入侵检测系统，帮助防止未授权人员访问您的信息。",
    privacyPolicyAnswer10:
      "这是一个面向普通受众的网站，不提供专注儿童的服务。 如果我们得知有 13 岁以下的儿童向我们发送个人信息，我们只会将该信息用于直接答复这名儿童，告知他或她我们在接收其个人信息之前必须获得家长同意。",
    privacyPolicyAnswer11:
      "如果您通过本网站的任何部分链接到其他网站，这些网站的运营不受本隐私政策的约束。 我们建议您查阅这些网站上张贴的隐私声明，了解它们收集、使用和披露个人信息的程序。",
    privacyPolicyAnswer12:
      "我们今后可能会更新本隐私政策。 如本隐私政策有重大变更，我们会将相关通知发送到您提供给我们的电子邮件地址，或者在我们网站上的显眼位置张贴通知。",
    privacyPolicyAnswer13:
      "如果您对本隐私政策（或您的旅游计划或购买物）有任何疑问，请通过电子邮件向我们发送客户服务和反馈表。\n" +
      "本隐私政策自 2014 年 8 月 1 日起生效。",
    backTop: "返回顶部",

    allOrders: "全部订单",
    refundOrders: "退票订单",
    changeOrders: "改签订单",
    pricesMinimum: "价格(最低)",
    pricesMaximum: "价格(最高)",
    durationMinimum: "飞行时长(最短)",
    durationMaximum: "飞行时长(最长)",
    pricesmum: "价格",
    durationmum: "飞行时长",
    departureEarliest: "去程出发时间(最早)",
    departureLatest: "去程出发时间(最晚)",
    arrivalEarliest: "去程到达时间(最早)",
    arrivalLatest: "去程到达时间(最晚)",

    returndepartureEarliest: "返程出发时间(最早)",
    returndepartureLatest: "返程出发时间(最晚)",
    returnarrivalEarliest: "返程到达时间(最早)",
    returnarrivalLatest: "返程到达时间(最晚)",

    passwordResetSuccessful: "密码重置成功",
    skipLoginPage: "跳转登录页",
    retrievePasswordByEmailAddress: "切换邮箱找回",
    retrievePasswordByPhoneNumber: "切换电话找回",
    emailRegistered: "该邮箱已注册",
    phoneNumberRegistered: "该手机号已注册",
    phoneNumberRegisteredNo: "该手机号未注册",
    imageVerificationCodeCannotBeEmpty: "图片验证码不能为空",
    passwordCannotBeEmpty: "密码不能为空",
    sentInBefore: "",
    sentIn: "后重新发送",
    registeredSuccessfully: "注册成功",
    registrationFailed: "注册失败",
    verificationCodeError: "验证码错误",
    activationCodeError: "激活码错误",
    emailRepeatError: "邮箱不能重复注册",
    congratulations: "恭喜您",
    pleaseEnterYourEmailAddressOrPhoneNumber: "请输入邮箱或手机号",
    passwordMustBeCharactersAndIncludeNumbersAndSymbols: "6-20位字母数字组合",
    tokenExpired: "Token过期请重新登陆",

    applyForRefund: "申请退票",
    applyForChange: "申请改签",
    sorry: "温馨提示",
    cannotFindTheFlight: "航班无数据",
    queryFails: "查询失败",
    systemError: "系统出错啦",
    payWithin30Minutes: "请尽快支付，该订单在30分钟内支付有效",
    toPay: "去我的行程中支付",
    waitingForTheResultOfPayment: "等待银行付款结果",
    toCheckOnMyItinerary: "去我的行程中查询",

    submittedPleaseWait: "正在提交中，请稍后",
    submittedSuccessful: "提交成功",
    addAirlineCard: "添加航司卡",
    failedAvailableData: "获取数据失败",

    //使用条款
    useProtocol: "客户与香港五洲國際旅遊有限公司之协议",
    useProtocolDetail1:
      "欢迎访问 Trip ",
    fiveContinentsInternationalTravelLimited: "香港五洲國際旅遊有限公司",
    useProtocolDetail2:
      "。“Trip 合作伙伴”指通过其提供链接、内容或服务的任何联合品牌和/或链接的网站。“您”一词系指访问本网站和/或在本网站上通过我们或我们的客服代理进行预订的客户。",
    useProtocolDetail3:
      "您仅可在不加修改地接受下述所有条款、条件及公告（统称为“使用条款”或“协议”）的情况下使用本网站。",
    useProtocolDetail4:
      "请仔细阅读这些使用条款，其中包含与责任限制和通过仲裁而非法庭解决争议相关的重要信息。",
    useProtocolDetail5: "您还应当阅读我们的",
    privacyPolicy: "隐私政策",
    useProtocolDetail6:
      "，该政策规定了您对本网站的使用，并通过引用纳入本协议。访问或使用本网站，在本网站预订任何旅游产品或服务，或与我们的客户服务中心人员联系，则表明您同意当时有效的使用条款适用。如果您不同意这些使用条款，请勿通过本网站或我们的客服人员进行预订。",
    useTheSite: "使用网站",
    useTheSiteEnsure: "作为使用本网站的条件，您保证：",
    useTheSite1: "1.您至少年满 18 周岁;",
    useTheSite2: "2.您拥有创设有约束力法律义务的法定权利；",
    useTheSite3: "3.您将遵守使用条款使用本网站;",
    useTheSite4:
      "4.您仅将本网站用于为您本人或在合法授权情况下为他人进行合法预订；",
    useTheSite5:
      "5.您将告知上述他人适用于您代其进行预订的使用条款，包括所有适用的规定和限制；",
    useTheSite6: "6.您在本网站上提供的信息真实、准确、最新且完整；",
    useTheSite7:
      "7.如果您拥有 Trip 账户，您将需要保护您的账户信息，并对您和其他人使用账户进行的任何活动进行监管以及承担完全责任。",
    useTheSite8:
      "我们保留以下权利：以任何理由（包括但不限于违反使用条款）随时自行决定拒绝任何人访问本网站及获得我们提供的服务。",
    controversy: "争议",
    controversy1:
      "Trip 致力于让客户满意，因此如果您有疑问或争议，我们会尽力为您解决问题。但是如果争议未能得到解决，您可以按照本部分的说明申请索赔。",
    controversy2: "您同意为我们提供机会通过联系",
    customerSupport: "客户支持",
    controversy3:
      "客户支持， 或拨打电话 （852）3193-9788 ，来解决与网站、我们的客服代理进行的任何交易、提供的任何服务或产品、我们作出的任何声明，或者我们的隐私政策（“索赔”）有任何关联的争议或索赔。如果我们无法在 60 天内处理索赔，您可以通过仲裁或小额诉讼法庭寻求解决，具体信息如下文所述。",
    controversy4: "除非您个人向小额诉讼法庭提出索赔并且这些法庭符合条件，",
    controversy5: "否则任何索赔都将通过具有约束力的仲裁而非法庭予以解决。",
    controversy6:
      "这包括您对我们、我们的子公司、旅游供应商，或者对经我们提供产品或服务的公司（它们是这一仲裁协议的受益方）提起的任何索赔。这也包括您在接受这些使用条款之前提起的任何索赔，无论此前版本的使用条款是否需要仲裁。",
    controversy7:
      "仲裁中没有法官或陪审团，并且法庭对仲裁裁决的审查有限。然而，仲裁员可以基于个人决断做出与法庭相同的赔偿和救济裁决（包括法定赔偿、律师费和花销），并且必须与法庭一样遵循和施行这些使用条款。",
    controversy8:
      "用于解决索赔的任何程序都将基于个案实施，不会按类别、合并或进行代表性诉讼。如果出于任何原因使得索赔程序通过法庭而非仲裁进行，我们均放弃申请陪审团审判的任何权利。仲裁决定可经由任何具备合法管辖权的法庭确认。",
    prohibitedActivities: "禁止的活动",
    prohibitedActivitiesAffirm:
      "本网站上的内容和信息（包括但不限于旅游服务的价格和可用性）以及提供该等内容和信息所使用的基础设施均为我们或我们的供应商和提供商的专有财产。尽管您可以对通过本网站预订的旅行或服务的旅行计划（及相关文档）进行有限数量的复制，但您同意不会对本网站上提供的或通过本网站获得的任何信息、软件、产品或服务进行修改、复制、分发、传播、展示、演示、再造、发布、许可、据以创作衍生作品、转让、销售或转售。另外您同意不执行以下操作：",
    prohibitedActivities1: "1.出于任何商业目的使用本网站或其内容；",
    prohibitedActivities2:
      "2.进行任何投机性、虚假或欺诈性的预订或根据任何预测性需求进行预订；",
    prohibitedActivities3:
      "3.未获得我们的明示书面同意，出于任何目的、使用任何机器人软件、爬虫软件、刷屏软件或其他自动方式或任何手动流程获取、监视或复制本网站的任何内容或信息；",
    prohibitedActivities4:
      "4.违反本网站上任何机器人排除标头中的限制，或者绕开或回避旨在防止或限制访问本网站的其他手段；",
    prohibitedActivities5:
      "5.实施任何导致或可能导致（由我们决定）我们的基础设施负载过重的行为；",
    prohibitedActivities6:
      "6.未获得我们的明示书面同意，出于任何目的深链接至本网站的任何部分（包括但不限于任何旅游服务的购买路径）；或者",
    prohibitedActivities7:
      "7.未事先获得我们的书面授权，以“框架”、“镜像”或其他方式在任何其他网站中包含本网站的任何部分。",
    prohibitedActivities8:
      "如果您的预订或账户存在欺诈、滥用或可疑活动迹象，Trip 可以取消与您的姓名、电子邮件地址或账户相关的任何旅游或服务预订，并关闭任何相关的 Trip 账户。如果您已进行任何欺诈活动，Trip 保留采取任何必要法律行动的权利，并且您可能需要因此向 Trip 赔偿金钱损失，包括诉讼费用和损害赔偿。如对预订取消、账户冻结或关闭存在异议，请联系 Trip 客服部。",
    privacyPolicyDetail:
      "Trip 主张保护您的隐私。请点击此处查看我们当前的隐私政策，了解我们的常规做法。如上所述，该政策还规定了您对本网站的使用，并通过引用隐私政策而纳入本协议：",
    supplierRulesAndRestrictions: "供应商的规则和限制",
    supplierRulesAndRestrictions1:
      "附加条款和条件将适用于您选择的旅游相关商品和服务的预订与购买。请仔细阅读这些附加条款条件。尤其是，如果您已购买了飞机票，请务必阅读旅行供应商在供应商网站发布的所有载运条款与条件。对于您选择与之进行交易的任何供应商，您同意遵守其购买条款与条件，包括但不限于支付全部应付金额，遵守供应商的费用、产品或服务的可用性方面的规定与限制。飞机票价仅在购买完成和机票发放后才有保障。航空公司和其他旅游供应商可以变更价格，恕不另行通知。如果我们没有按时收到您的全额付款，我们有权取消您的预订。",
    supplierRulesAndRestrictions2:
      "Trip 可能会向您提供预订两张单程票组合，而非往返机票的机会。两张单程机票的价格通常更便宜，而且航班的选择范围更广，您可以选择相同的航空公司，也可选择不同的航空公司。与往返机票不同，每张单程机票都会受到所属航空公司的规定、限制和费用的影响。如果其中一个航班受到航空公司变更的影响（如航班取消或改期），客户就必须改签另一个航班，客户须负担改签未受影响航班所产生的所有费用。",
    supplierRulesAndRestrictions3:
      "对于某些低成本航空公司，您的航班票价已从其它货币换算为您的本地货币，便于您估计购票金额。因此，当您预订时，由于汇率波动航空公司从您的信用卡上所扣取的金额可能略有不同。您的对账单可能还包括您的发卡机构处理交易时产生的费用，以及进行国际购物时产生的任何适当税款。",
    supplierRulesAndRestrictions4:
      "联邦法律禁止在通过行李中夹带或是随身的方式携带任何危险品登机。违反规定者可处以五年监禁和 25 万美元或以上的罚款 (49 U.S.C. 5124)。危险品包括爆炸物、压缩气体、可燃性液体和固体、氧化剂、毒物、腐蚀性和放射性物质。示例：油漆、打火机液、烟花、催泪瓦斯、氧气瓶和放射性药品。特殊例外情况有，行李中的少量（总计最多 70 盎司）药品和盥洗用品，以及随身携带的某些烟草用品。",
    supplierRulesAndRestrictions5:
      "您确认，一些提供某些服务和/或活动的第三方供应商可能要求您先签署免责声明书后，再参加他们提供的服务和/或活动。您明白，任何违反上述供应商规则和限制的行为均可能导致您的预订被取消、导致您被拒绝访问相应的旅游产品或服务、导致您丧失所支付的预订费用、和/或导致我们将该违反行为对我们造成的任何费用记入您账户。",
    bankAndCreditCardFees: "银行和信用卡费用",
    bankAndCreditCardFees1:
      "当旅行供应商处理您的付款时，您的付款将在供应商总部所在的国家/地区处理。",
    bankAndCreditCardFees2:
      "Trip 或旅行供应商可能会验证：(i) 付款卡的有效性（通过收取一项可在数日内进行退款的或可由旅行供应商从最终付款中扣除的票面值），及 (ii) 付款卡的资金可用性（由您的信用卡发卡行确认）。",
    bankAndCreditCardFees3:
      "一些银行和信用卡公司会收取国际或跨国交易费用。例如，如果您使用美国银行发行的卡预订非美国商家的产品/服务，您的银行可能会向您收取跨境或国际交易费。而且，您的银行或信用卡公司可能将您的国际旅行预订视为国际交易，因为我们可能会将您的卡片详细信息提供给国际旅行供应商作付款之用。此外，一些银行和信用卡公司会收取外币兑换费。例如，如果您在预订时使用的货币与信用卡所用的货币不同，您的信用卡公司可能会将预订金额兑换为您的信用卡所用的货币单位，并收取外币兑换费。货币汇率和外币交易费完全由您的银行在处理交易的当天决定。如果您对此类费用或预订所适用的汇率有任何疑问，请联系您的银行。",
    currencyConverter: "货币换算器",
    // currencyConverter1:'如果本网站提供货币换算器，则下述条款和条件适用：汇率基于各种公开来源提供的数据，仅供参考。我们没有验证汇率的准确性，实际汇率可能有所变化。货币报价并非每天更新。请检查货币转换器功能上的日期，了解最新更新之日的汇率。此应用程序提供的信息被认为是准确的，但 Trip 公司、Trip 合作伙伴和/或我们各自的供应商不担保或保证其准确性。在将此信息用于金融目的时，我们建议您咨询合格的专业人员，查证汇率的准确性。我们不授权将此信息用于您个人使用之外的任何目的，明确禁止您转售、再分发此信息和将其用于商业目的。' +
    //                     '国际旅游您负责确保您符合外国人入境要求，确保您的旅游证件，如护照和签证（过境、商务、旅游及其他）齐全并满足任何其他外国人入境要求。Trip 不具备有关外国人入境要求或旅游证件的专业知识。在预订国际旅行目的地之前，我们强烈建议客户查看旅行禁令、警告、通告及相关政府发布的公告。护照和签证：您必须咨询相关大使馆或领事馆了解相关信息。要求可能会有变化，在预订和动身之前，您应适时了解最新的信息。如果因您没有携带任何航空公司、管理机构或国家（包括您只是过境的国家）要求的正确的护照、签证或其他旅游证件而被拒绝登机或进入任何国家，我们不承担任何责任。' +
    //                     '这包括飞机造成的全部停留，即使您没有离开飞机或机场。健康：推荐的旅游接种可能发生变化，您应在动身之前咨询您的医生，了解当前推荐的接种疫苗。您应负责确保您满足所有健康入境要求，进行推荐的接种，携带所有推荐的药物，并遵守与您的旅途相关的所有医嘱。灭虫：尽管不常发生，但大多数国家/地区保留在明显对公共卫生、农业或环境构成威胁时，对飞机进行灭虫的权力。国际卫生组织和国际民航组织已批准下述灭虫程序：(1) 乘客在飞机上时在客舱内喷洒雾化杀虫剂，或者 (2) 乘客不在飞机上时用残留杀虫剂处理航空器内表面。' +
    //                     'Trip 提供特定国际目的地的旅游产品预订，并不代表其声明或保证前往此地区旅行是可取的或没有风险，Trip 也不承担到此地区旅游所可能造成的伤害或损失的责任。',
    currencyConverter1:
      "如果本网站提供货币换算器，则下述条款和条件适用：汇率基于各种公开来源提供的数据，仅供参考。我们没有验证汇率的准确性，实际汇率可能有所变化。货币报价并非每天更新。请检查货币转换器功能上的日期，了解最新更新之日的汇率。此应用程序提供的信息被认为是准确的，但 Trip 公司、Trip 合作伙伴和/或我们各自的供应商不担保或保证其准确性。在将此信息用于金融目的时，我们建议您咨询合格的专业人员，查证汇率的准确性。我们不授权将此信息用于您个人使用之外的任何目的，明确禁止您转售、再分发此信息和将其用于商业目的。",
    InternationalTourism: "国际旅游",
    InternationalTourism1:
      "您负责确保您符合外国人入境要求，确保您的旅游证件，如护照和签证（过境、商务、旅游及其他）齐全并满足任何其他外国人入境要求。Trip 不具备有关外国人入境要求或旅游证件的专业知识。在预订国际旅行目的地之前，我们强烈建议客户查看旅行禁令、警告、通告及相关政府发布的公告。",
    InternationalTourism2:
      "护照和签证：您必须咨询相关大使馆或领事馆了解相关信息。要求可能会有变化，在预订和动身之前，您应适时了解最新的信息。如果因您没有携带任何航空公司、管理机构或国家（包括您只是过境的国家）要求的正确的护照、签证或其他旅游证件而被拒绝登机或进入任何国家，我们不承担任何责任。这包括飞机造成的全部停留，即使您没有离开飞机或机场。",
    InternationalTourism3:
      "健康：推荐的旅游接种可能发生变化，您应在动身之前咨询您的医生，了解当前推荐的接种疫苗。您应负责确保您满足所有健康入境要求，进行推荐的接种，携带所有推荐的药物，并遵守与您的旅途相关的所有医嘱。",
    InternationalTourism4:
      "灭虫：尽管不常发生，但大多数国家/地区保留在明显对公共卫生、农业或环境构成威胁时，对飞机进行灭虫的权力。国际卫生组织和国际民航组织已批准下述灭虫程序：(1) 乘客在飞机上时在客舱内喷洒雾化杀虫剂，或者 (2) 乘客不在飞机上时用残留杀虫剂处理航空器内表面。",
    InternationalTourism5:
      "Trip 提供特定国际目的地的旅游产品预订，并不代表其声明或保证前往此地区旅行是可取的或没有风险，Trip 也不承担到此地区旅游所可能造成的伤害或损失的责任。",
    disclaimerDetail: "免责声明",
    disclaimerDetail1:
      "此网站上公布的信息、软件、产品及服务可能存在误差或错误，包括价格错误。特别要指出的是，Trip 公司以及 Trip 合作伙伴不保证本网站上显示的航班及其他旅行产品和服务的信息和描述（包括但不限于定价、照片、一般产品描述等）的正确性，也不对与此类信息和描述相关的任何错误或其他误差承担任何责任。此外，Trip 明确保留纠正我们网站上的任何定价错误和/或按照错误价格进行的预订的权利。",
    disclaimerDetail2:
      "Trip 公司、Trip 合作伙伴及其各自的供应商不对本网站上所包含的信息、软件、产品和服务针对任何目的的适用性做任何声明；在本网站上包含或提供任何产品或服务不构成 Trip 公司或 Trip 合作伙伴对此类产品或服务作出的任何认可或推荐。所有此类信息、软件、产品及服务均“按原样”提供，不含有任何保证。Trip 公司、Trip 合作伙伴及其各自的供应商拒绝承认任何担保及条件，即本网站、网站服务器或 Trip 公司、Trip 合作伙伴和/或其各自的供应商所发送的任何电子邮件不含病毒或其他有害组件。Trip 公司、Trip 合作伙伴及其各自的供应商在此拒绝承认与此信息、软件、产品和服务有关的所有担保及条件，包括所有对适销性、特定用途适用性、产权和非侵权性的默示担保及条件。",
    disclaimerDetail3:
      "在本网站上提供旅行服务或其他服务的承运商及其他供应商为独立的立约方，并非 Trip 公司或 Trip 合作伙伴的代理或员工。Trip 公司和 Trip 合作伙伴不对任何此类供应商的行为、错误、失职、声明、担保、违规或疏忽负责，也不对由此造成的任何人身伤害、死亡、财产损害或由此产生的其他损害或费用负责。如果发生延迟、取消、过量预订、罢工、不可抗力或其他超出直接控制范围之事由，Trip 公司和 Trip 合作伙伴不承担任何责任且不予退款，并且不对任何额外费用、失职、延迟、重新安排路线或任何政府或机构的行为负责。",
    disclaimerDetail4:
      "对于您访问、展示或使用本网站引起或与此相关，或与延迟或无法访问、展示或使用本网站相关的任何直接、间接、惩罚性、附带性、特殊或后果性损害赔偿（包括但不限于您对本网站上的观点的依赖；任何计算机病毒、信息、软件、链接的网站、通过本网站获取的产品和服务；或由访问、展示或使用本网站引起），Trip 公司、Trip 合作伙伴和/或其各自的供应商在任何情况下均不承担责任，不论是基于过失论、合约、侵权、严格责任、消费者保护法或其他，且即使在 Trip 公司、Trip 合作伙伴和/或其各自的供应商已被告知该类损害赔偿的可能性的情况下也是如此。",
    disclaimerDetail5:
      "尽管有以上规定，但如果 Trip 公司、Trip 合作伙伴或其各自的供应商被认定对由任何上述情形引起或与之相关的任何损失或损害负有责任，则 Trip 公司、Trip 合作伙伴和/或其各自的供应商的责任在任何情况下总计不得高于以下费用中的较高者：(a) 您为本网站上的此类交易向 Trip 支付的服务费用，或 (b) 一百美元 (US$100.00) 或以当地货币计算的等值金额。",
    disclaimerDetail6:
      "责任限制反映了双方之间的风险分配。如果本使用条款所述的任何有限补救未能达到其基本目的，本节所述限制将继续有效并适用。本使用条款规定的责任限制有利于 Trip 公司、Trip 合作伙伴和/或其各自的供应商。",
    theCompensation: "赔偿",
    theCompensation1:
      "对于第三方因下列原因向 Trip 公司、Trip 合作伙伴和/或其各自的供应商及其任何高管、总监、员工和代理提出的任何索赔、诉讼、要求、追偿金、损失、损害赔偿金、罚款、罚金或其他任何类型或性质的费用或开支，包括但不限于合理的法律费用和会计费用，您同意为其进行辩护并进行相应赔偿：",
    theCompensation2: "您违反本使用条款或使用条款引用的文档；",
    theCompensation3: "您违反任何法律规定或影响第三方权利；",
    theCompensation4: "您对此网站的使用。",
    thirdPartySiteLinks: "第三方网站链接",
    thirdPartySiteLinksDetail:
      "本网站可能含有 Trip 之外的第三方运营的网站超链接。该等超链接仅供您参考。我们对此类网站没有控制权，不对此类网站的内容或隐私权或其他做法负责。此外，您应采取预防措施，确保您选择的任何链接或您下载的软件（不论从此网站还是其他网站）不含病毒、蠕虫、特洛伊木马病毒、缺陷及其他具有破坏性的项目。我们包含对此类网站的超链接不意味着我们认可此类网站的内容，或与此类网站的运营商有任何关系。",
    softwareProvidedOnThisSite: "此网站提供的软件",
    softwareProvidedOnThisSite1:
      "可以从本网站或通过包括 Trip 移动应用（以下简称“移动应用”）在内的移动应用商店下载的任何软件（以下简称“软件”），均为 Trip 公司和/或我们各自供应商的受版权保护的产品。您对此类软件的使用受最终用户许可协议（如果有）的条款约束，该协议与软件同时提供或包含在软件中（以下简称“许可协议”）。您只有首先同意附于软件或软件所含的许可协议的条款，才能安装或使用该软件。对于本网站上可以下载的没有随附许可协议的任何软件，我们特此授予您（用户）有限的、个人的、非独占且不可转让的许可，以根据本使用条款下载、安装和使用软件和/或移动应用，以查看或以其他方式使用本网站和/或访问移动应用中可用的内容和信息（包括但不限于旅游服务的价格与可用性），但不得用于其他目的。",
    softwareProvidedOnThisSite2:
      "请注意，所有软件（包括但不限于本网站上包含的所有 HTML 代码和 Active X 控件）均为 Trip 公司、Trip 合作伙伴和/或我们各自的供应商所有，受版权法和国际公约的相关规定的保护。软件的任何复制或再分发均受到明令禁止，且可能导致严重的民事和刑事处罚。违者将受到最严厉的处罚。",
    softwareProvidedOnThisSite3:
      "明确禁止将软件复制或再分发到任何其他服务器或地点进行进一步复制或再分发，本条款不限制上述条文。如果需要授权软件，将仅根据许可协议的条款进行授权。",
    softwareProvidedOnThisSite4:
      "您的移动设备必须连接至互联网，以使移动应用正常运行。您应负责进行所有必要的安排，以使您的移动设备连接至互联网，您还应承担服务提供商向您收取的移动应用收发数据所产生的全部费用（包括但不限于数据漫游费用）。正如我们的隐私政策所述，作为正常运行的一部分，移动应用将会自动传送少量的数据，包括您使用移动应用的方式、您访问的内容、应用程序在使用时遇到的技术错误或问题。使用移动应用，即表明您确认并同意对此类信息的自动收集。",
    commentsPhotosAndOtherSubmittedContent: "点评、评论、照片和其他提交内容",
    commentsPhotosAndOtherSubmittedContent1:
      "我们欢迎您提出反馈意见和建议。请注意，通过电子邮件、在本网站上发布内容或以其他方式向本网站提交内容（包括任何点评、照片、视频、问题、评论、建议、想法或类似内容，统称“提交内容”），即表明您向 Trip 以及我们通过其提供服务的关联、联合品牌和/或链接的网站合作伙伴（统称“Trip 合作伙伴”）授予非独家、免版税、永久、可转让、不可撤销且完全可转让许可的权限进行以下行为：" +
      "(a) 在全球范围内现在已知或以后出现的任何媒体上使用、复制、修改、改编、翻译、分发、发布、据此创作衍生内容、公开展示及演示此类提交内容；以及 (b) 使用您在此类提交内容中提交的姓名。您确认，Trip 公司可以自行选择提供您的点评或评论的归属信息（如在您提交的评论中列出您姓名和家乡），该类提交内容可能会与我们的供应商合作伙伴分享。您进一步授权 Trip 公司，可以对违反这些使用条款而侵犯您或 Trip 公司在该提交内容中的权利的个人或实体依法进行追究。您确认并同意，意见不具有机密性和专属性。" +
      "您明确放弃您所提交内容的任何“著作人身权”（包括归属权或完整权），并同意您对我们、Trip 合作伙伴或者我们的任何合作伙伴或被许可人发布、使用、修改、删除或利用您的提交内容无任何异议。我们对您发布或提交的任何意见概不负责。对于您的评论，我们无发布的义务；我们可以全权决定要在网站发布哪些评论。如果您不同意这些使用条款，则请勿向我们提供任何意见。",
    commentsPhotosAndOtherSubmittedContent2:
      "您对您的意见内容（特别是，包括但不限于发布到此网站的评论）负有完全责任。您不得向/从本网站发布或散播以下内容：(i) 任何不合法、恐吓、诽谤、中伤、淫秽、色情信息，或者侵犯公开权和/或隐私权或违反任何法律的其他材料或内容；(ii) 任何商业材料或内容（包括但不限于筹集资金、任何商品或服务的广告或推广）；以及 (iii) 侵犯、滥用或违反任何第三方的任何版权、商标、专利权或其他专有权利的任何材料或内容。对于违反上述限制所造成的损害，或您在此网站上发布的内容所造成的其他任何伤害，您应独自承担全部责任。您确认，Trip 可以行使针对您提交的任何内容的权利（如使用、出版、删除），恕不另行通知。",
    commentsPhotosAndOtherSubmittedContent3:
      "对于第三方针对本网站内容（包括任何提交内容）侵犯上述第三方的版权而提出索赔，Trip 对该等第三方权利的主张政策见下述“版权侵犯索赔”。",
    commentsPhotosAndOtherSubmittedContent4:
      "本网站配有 Google® 翻译工具，使您能够翻译用户生成的评论等内容。Google® 翻译工具通过自动程序翻译文本，这可能使文本不准确。使用 Google® 翻译工具带来的风险完全由您自行承担。Trip 对 Google® 翻译提供的翻译准确性或完整性不做出保证、承诺、确保或保障。",
    copyrightAndTrademarkDeclaration: "版权和商标声明",
    copyrightAndTrademarkDeclaration1:
      "此网站上全部内容均归 香港五洲国际旅游有限公司版权所有。保留所有权利。Trip Trip、Trip 徽标均是香港五洲国际旅游有限公司在其他国家的注册商标或商标。本使用条款中提及的其他徽标和产品及公司名称可能是其各自所有者的商标。香港五洲国际旅游有限公司对网站上 Trip 之外各方运营的内容不承担责任。",
    copyrightAndTrademarkDeclaration2:
      "如果您注意到存在对我们品牌的侵权行为，请通过邮件告知我们reynold.zhang@5u6o7se0.dingmail.work 此电子邮件地址只负责处理品牌侵权的相关信息。",
    accountTermination: "账户终止",
    accountTerminationDetail:
      "根据《千禧年数字版权法案》(“DMCA”)和其他适用法律，Trip 已经实施了一项账户终止政策，可在相应情况下由Trip 自行决定终止被认为重复侵权的订阅人或账户持有人的访问权限。对于侵犯他人任何知识产权的用户，不论是否为多次侵权，Trip 均可以自行限制该用户对网站的访问和/或终止其账户。如果您认为某账户持有人或订户为屡次侵权人，请在提交通知时提供充分的信息，以便我们查证该账户持有人或订户是否为屡次侵权人。",
    noticeOfInfringement: "侵权材料通知",
    noticeOfInfringementDetail:
      "如果您有充分的理由认为我们托管的材料侵犯了您的版权，您（或您的代理人）可寄给我们一则书面通知，通知中包含以下信息。请注意，如果您的投诉填写不当或不完整，我们将不会处理您的投诉。您在通知中有关正在侵权的内容或活动的任何虚假陈述均有可能使您面临损害赔偿。",
    noticeOfInfringement1: "1.明确指出您声称受到侵权的受版权法保护的作品。",
    noticeOfInfringement2:
      "2.明确指出本网站上您声称受到侵权的材料，例如指向侵权材料的链接。",
    noticeOfInfringement3: "3.您的姓名、地址、电子邮件地址和电话号码。",
    noticeOfInfringement4:
      "4.声明“您有充分的理由认为，声称侵犯版权的材料未获得版权所有人、代理人或法律的授权。",
    noticeOfInfringement5:
      "5.声明“通知中的信息准确无误，并且投诉方已获得授权，可代表宣称受到侵犯的专属权利的所有人 - 如有不实，当受伪证罪之处罚。",
    noticeOfInfringement6:
      "6.通知必须由已获授权的人签署，此人有权代表宣称受到侵犯的专属权利的所有人。",
    noticeOfInfringement7:
      "您可将您的通知发送到我们的电子邮件地址：reynold.zhang@5u6o7se0.dingmail.work，或发送传真至 （852）3193-9788，或通过下述联系信息将通知发送给我们。",
    objectionToInform: "异议通知",
    objectionToInformDetail:
      "如果您发布的材料已下线，我您可通过传真或普通邮件向我们发送一份异议通知，通知须包含下列事项。在发出异议通知之前，您可以寻求法律咨询。请包含下述详细内容：",
    objectionToInform1:
      "1.说明已删除或禁止访问的具体内容以及该内容之前在 Trip 网站出现的位置。如有可能，请提供 URL 地址。",
    objectionToInform2: "2.您的姓名、通信地址、电话号码和电子邮件地址。",
    objectionToInform3:
      "3.一份声明，表明您同意您的地址所处司法管辖区的联邦地区法院的管辖权，或者如果您的地址不在美国境内，您同意 Trip 所处的任何司法管辖区的联邦地区法院的管辖权；您还应声明您会接受举报您的内容的一方或该方代理人送达的法律程序文件。",
    objectionToInform4:
      '3.下述声明：“我发誓，根据伪证处罚条款，我有充分的理由相信以上所确定内容因错误或错判而被删除或禁用。"',
    objectionToInform5: "在文件上签字。",
    objectionToInform6: "将书面通知发送至下列地址：",
    objectionToInform7:
      "香港五洲國際旅遊有限公司.\n" + "九龍旺角彌敦道739號金輪大廈15樓G室",
    objectionToInform8:
      "您也可以发送传真至：（852）3193-9788，如有任何针对 Trip 的 DMCA 程序相关的其他疑问，请拨打电话 （852）3193-9788 联系我们。",
    thePatentStatement: "专利声明",
    thePatentStatementDetail:
      "香港五洲國際旅遊有限公司拥有的一个或多个专利可能适用于本网站和适用于可以通过本网站访问的功能和服务。本网站的部分页面是在一个或多个专利的许可下运营。其他专利正在申请中。",
    mapTerms: "地图条款",
    mapTermsDetail:
      "您在使用本网站的地图功能时，须遵守 Microsoft 使用条款、Microsoft 隐私声明、Google 使用条款和 Google 隐私声明。Microsoft 和 Google 有权随时自行变更他们的使用条款和隐私声明。请点击此处了解更多信息：",
    mapTerms1: "http://privacy.microsoft.com/en-us/default.mspx",
    mapTerms2: "http://www.microsoft.com/maps/assets/docs/terms.aspx",
    mapTerms3: "http://www.google.com/privacy/privacy-policy.html",
    mapTerms4:
      "http://www.google.com/enterprise/earthmaps/legal/us/maps_AUP.html",
    mapTerms5: "http://www.maps.google.com/help/legalnotices_maps.html",
    mapTerms6: "http://maps.google.com/help/terms_maps.html",
    mapTerms7:
      "地图中所用的 OpenStreetMap 地理数据由 (c) OpenStreetMap 提供，根据开放数据库许可 开放数据库许可 (ODbL) 使用",
    generalPrinciples: "一般原则",
    generalPrinciples1:
      "本使用条款受美国联邦仲裁法案和联邦仲裁法律的约束，且对于美国居民进行的预订，本使用条款还受其帐单地址所在州的法律之约束，无论是否存在法律冲突原则。在任何不承认本协议所有条款（包括但不限于本段落）均有效的司法管辖权地使用本网站均被视作未经授权使用。",
    generalPrinciples2:
      "您同意签署本协议或使用本网站不代表您和 Trip 公司之间存在合资、合作或雇佣关系。",
    generalPrinciples3:
      "我们对该协议的履行遵从现有法律及法务流程。对于您对本网站的使用或您向我们提供或我们收集的关于该使用的信息，该协议不限制我们使用这些信息以遵守执法部门或其他政府或法律请求或要求。",
    generalPrinciples4:
      "若该协议的任一部分被确认为无效、违法或不可执行，其余条款的有效性、合法性和可执行性将不受到任何形式的影响或损害。我们在任何时间对该协议中任一条款的执行失败或延迟执行不代表我们放弃在未来执行该条款或其他任何条款的权利。",
    generalPrinciples5:
      "本协议（以及本协议所引用的任何其他条款和条件）构成您与 Trip 之间就本网站、我们的服务以及您与我们之间的交易和关系而达成的完整协议，并取代我们双方所有先前或当前的电子、口头或书面通信和建议。协议的打印版和任何电子形式的通知在基于协议或与协议有关的司法或行政诉讼中应受到同样范围的采纳，并应和其他最初以印刷形式产生并维护的业务文件及记录一样受相同条件的约束。",
    generalPrinciples6:
      "此网站提及的虚构公司名、产品名、人名、人物和/或数据无意描述任何真实的个人、公司、产品或事件。",
    generalPrinciples7: "我们保留本协议没有明确授权的所有权利。",

    ///////
    adultsAndChildrenCannotExceed9: "总人数不超过9人.",
    oneAdultsOnlyOnebaby: "每位成人仅可携带 1 名婴儿 (0-2 岁)",
    pay: "付款",
    onward: "去程",
    return1: "返程",
    enterPhoneNumber: "请输入手机号码",
    enterYourMailAddress: "请输入电子邮箱",
    payImmediatelyAfterPurchase: "购买成功请立即支付",
    cabinSoldOut: "舱位已售完",
    numberOfCabinIsInsufficient: "舱位数不足",
    systemError: "系统错误",
    failureOfReservation:
      "我们检测到您可能在其它平台/系统使用同样客户信息预定相同的航班舱位信息，导致订位失败！",
    toA: "至",
    priceCheckFailed: "很抱歉，您选择的价格舱位已销售完，请重新查询!",
    recheckTheFlight: "您需要返回机票查询页面,重新查询航班",
    mailAddressOrPhoneNumberError: "邮箱或手机错误",
    loggingIn: "登陆中",
    passwordPassed: "密码通过",
    loginSuccess: "登录成功",
    loginAgain: "请重新登录",
    enterTheCorrectEmailFormat: "请输入正确的邮箱格式",
    refundOrChangeRules: "退改规则",
    refundRules: "退票规则",
    changeRules: "改签规则",

    nodataMessage1: "我们搜索了400多家航空公司的信息，未找到任何在",
    nodataMessage2: "从",
    nodataMessage3: "的去程航班",
    nodataMessage4: "下面的小提示可以帮您找到合适的航班：",
    nodataMessage5: "将到达或出发目的地改为附近的机场。",
    nodataMessage6: "尝试将到达或出发日期提前或者推迟一天。",
    nodataMessage7: "的返程航班。",

    nodataConditionsMessage1: "您选择的筛选条件过多，未找到完全符合的航班",
    nodataConditionsMessage2: "可以减少筛选条件得以找到较为符合您的航班。",
    nodataConditionsMessage3: "选择您搜索结果的其它航班。",

    refreshSearch:
      "航班价格经常随供需变化发生波动。我们希望确保您看到的是最好的价格，而且是有保证的价格。",
    refreshSearchTitle: "请刷新搜索，以了解最新价格。",
    okrefresh: "刷新搜索",
    tips: "提示",
    segment: "航段",
    priceOfYourScheduledFlightHasFluctuated: "您所预定的航班价格发生波动",
    afterChange: "变更后",
    travelPrice: "行程总价",
    returnBack: "返回",
    loginSuccessLoading: "登录成功，加载中...",
    onwardSegment: "去程航段",
    returnSegment: "返程航段",
    accountOrPasswordError: "用户名或密码错误",
    pleaseEnterTheNameOfThePassport: "请输入护照上的名字",
    ticketsZ: "张票",
    loadingmessage: "正在处理您的请求...",
    pleaseEnter: "请输入",
    isloginout: "是否确定注销登录？选择确定将为您跳转至首页。",
    agreeoneworldtrip: "请同意遵守规则",

    //客服中心
    airlineReservationConfirmation: "查看您的机票预订确认",
    operationSteps: "操作步骤",
    operationSteps1: "前往我的行程查看、通过电子邮件发送或打印您的行程或收据。",
    operationSteps2: "查看确认邮件。",
    operationSteps3: "如果您预订时未登录，请前往查找行程。",
    operationSteps4: "如果您在我的行程中没有看到您的行程，可能是因为：",
    operationSteps5: "您预订时并未登录。",
    operationSteps6:
      "您预订时使用了Trip 积分。这些订单最多可能需要24小时才会在我的行程中显示出来。 ",
    friendshipHints: "友情提示",
    friendshipHints1: "有关行李的信息，请参阅行李费用和限额。",
    friendshipHints2: "要提出特殊要求，比如餐点或轮椅，请直接联系航空公司。",
    friendshipHints3:
      "如果您通过航空公司直接进行变更，这些变更不会出现在您的行程中。",
    anyOtherAssistance: "需要其他协助？",
    anyOtherAssistanceDetail:
      "如果您尚未收到您的确认邮件或需要查看预订的帮助，请联系我们 。",
    luggage: "行李",
    checkItinerary: "检查行程单",
    howToOperateConcretely: "如何具体运作",
    howToOperateConcretelyDetail:
      "行李费和限重取决于航空公司和预订的机票类型。",
    checkRelativeBaggageTicket:
      "要查看特定机票的相关行李信息，请进行以下操作：",
    checkRelativeBaggageTicket1: "登录账户，查看订单。",
    checkRelativeBaggageTicket2: "选择您的行程单。",
    moreInformationContactYourAirlineDirectly:
      "如需以下方面的更多信息，请直接联系您的航空公司：",
    moreInformationContactYourAirlineDirectly1: "托运行李所含物品",
    moreInformationContactYourAirlineDirectly2: "随身行李限重",
    moreInformationContactYourAirlineDirectly3: "附加行李费",
    moreInformationContactYourAirlineDirectly4: "违禁物品",
    moreInformationContactYourAirlineDirectly5: "超大行李政策",
    moreInformationContactYourAirlineDirectly6: "运动装备",
    moreInformationContactYourAirlineDirectly7: "无障碍设施的提供和使用",
    aRoundTripContaining2OneWayTickets: "包含 2 张单程票的往返机票",
    aRoundTripContaining2OneWayTicketsDetail:
      "部分往返机票包含 2 张单程票，每张单程票要求遵循各自的规定和限制。如果这种组合机票的价格比常规往返票价更具竞争力，我们将提供组合机票供预订，并为您提供更合适的选择。",
    book: "预订",
    book1: "这种往返机票只能在线预订。",
    book2:
      "行李政策因航空公司而异。有关详情，请参阅每张机票对应的行李费用和限额以及航空公司费用。",
    changeAndRefundDetail1:
      "每张单程票只能单独改签或退票。改签或退票往返机票中的一张机票不会自动更新或影响另外一张机票。",
    changeAndRefundDetail2:
      "您的一张单程票发生由航空公司自主的时间表变更时，另外一张单程票不会自动更新。要变更另一张机票，则可能需要支付变更手续费。欢迎联系我们以获得帮助。",
    changeAndRefundDetail3:
      "如果您的其中一张机票为低成本航空公司机票，您必须直接联系该航空公司进行变更。然后，请联系我们变更旅行中预订的第二张机票（如果需要的话）。",
    changeAndRefundDetail4:
      "如果两张单程票均为低成本航空公司机票，请直接联系相关的各家航空公司来变更或取消机票。",
    changeAndRefundDetail5:
      "变更或取消机票前，请查阅行程，了解航空公司收取的变更和取消费用。",
    changeFlightSchedule: "改签机票",
    lowCostAirlines: "低成本航空公司",
    lowCostAirlines1: "低成本航空公司，要求您直接联系航空公司以变更您的航班。",
    lowCostAirlines2: "含 2 张单程票的往返机票",
    lowCostAirlines3:
      "如果您的往返机票包含 2 张单程机票，请参阅含 2 张单程票的往返机票。",
    flightChangeFee: "航班改签费用",
    flightChangeFee1:
      "变更总费用取决于您的机票价格及航空公司可能收取的任何费用。您的改签费用可能包括：",
    flightChangeFee2: "每张机票的航空公司航班变更费用。",
    flightChangeFee3: "机票差价（如果改签后的航班价格超过原航班价格）。",
    toEstimateTheCostOfChangingFlights: "如要估算航班改签费用",
    toEstimateTheCostOfChangingFlights1: "请登录账户，查看订单。",
    toEstimateTheCostOfChangingFlights2: "在我的行程中，选择要改签的行程单。",
    changingHelp: "如果您在改签机票方面需要协助，请联系我们。",
    refundATicket: "退票",
    lowCostAirlinesRequireDirectlyCancelFlight:
      "低成本航空公司，要求您直接联系航空公司以取消您的航班。",
    contactUsAssistanceCancelingAirlineTickets:
      "如果您在取消机票方面需要协助，请联系我们。",
    refundATicketDetail:
      "取消航班之前，请查看您的行程中关于航班条款与规定部分，了解可能产生的航班取消费用。可能产生的费用一律由航空公司（而非我们）要求收取。",
    cancelYourAirlineTicketOnline: "在线取消您的机票预订",
    cancelYourAirlineTicketOnline1: "登录账户，查看订单。",
    cancelYourAirlineTicketOnline2: "在我的行程中，选择要取消的行程单。",
    cancelYourAirlineTicketOnline3:
      "要取消此类往返机票，您必须分别取消每张单程票。如果其中一张机票为低成本航空公司机票，您必须直接联系该航空公司进行变更。如需了解更多信息，请参阅含 2 张单程票的往返机票。",
    refundHints1:
      "如果您未搭乘去程航班，航空公司将自动取消您的返程航班，除非您预订的往返机票含 2 张单程票。",
    refundHints2: "如果航空公司取消了您的航班，请参阅航空公司主动变更行程。",
    refundHints3: "有关航班保险的信息，请参阅航班保险规则。",
    refundHints4: "有关退款信息，请参阅航司退款规则。",
    airlinesIndependentlyChangeSchedules: "航空公司自主对时间表做出变更",
    airlinesIndependentlyChangeSchedulesDetail:
      "有时候基于各种原因，如航班号、飞行路线或起飞时间的调整，航空公司会自主对时间表做出变更。如果航空公司自主对您的航班行程做出变更，则不会向您收取变更费或机票差价。",
    lowCostAirlinesIndependently1:
      "如果您通过低成本航空公司预订机票，请直接联系航空公司，处理任何时间表变更相关的问题。我们的客服无法对低成本航空公司的预订做出任何变更。",
    lowCostAirlinesIndependently2:
      "如果您的行程中仅有一张机票属于低成本航空公司，并且是该航空公司自主对该航班做出变更，请按以下步骤操作：",
    lowCostAirlinesIndependently3: "联系低成本航空公司，对您的预订做出变更。",
    lowCostAirlinesIndependently4:
      "一旦您与该低成本航空公司确认变更后，如果还需要对您的其余行程做出任何额外变更，请联系我们。",
    omniServiceAirlines: "全方位服务航空公司",
    omniServiceAirlines1:
      "如有时间表变更，我们将与您的航空公司紧密协作，以提供与您的原始航班相当的新航班选项。我们确定了相当的航班选项后，就会通过电子邮件或电话联系您以说明详情。",
    omniServiceAirlines2:
      "对于某些时间表变更，您不必做任何事。但在另一些情况下，您可能需要采取相应行动，取决于我们发送给您的航空公司时间表变更通知。",
    changeNotificationEmail: "当您收到变更通知邮件",
    changeNotificationEmail1:
      "查看时间表变更的详细信息，并遵照邮件中的说明操作。",
    changeNotificationEmail2:
      "根据时间表变更的类型，您可能需要或无需联系我们来确认变更。",
    changeNotificationEmail3:
      "时间表变更完成后，我们将发送包含更新行程的确认邮件给您。",
    changeNoticePhoneNumber: "当您接到变更通知电话",
    changeNoticePhoneNumber1:
      "有时候，除了发送有关变更的邮件给您，我们还会尝试通过电话联系您。",
    changeNoticePhoneNumber2:
      "当我们与您确认了航班变更并且获得航空公司批准之后，我们将会发送包含更新行程的确认邮件给您。",
    notificationFriendshipHints1:
      "如果您最初购买机票时付费订了座位或购买了其他升级服务，请直接联系相关航空公司，确保这些服务会转移到您的新机票上。",
    notificationFriendshipHints2:
      "航空公司自主的时间表变更完成后，未来若您需要对该机票做出任何变更，将需遵守原始机票的规定和限制。请查阅变更机票了解进一步信息。",
    welcomeContactUsForHelp: "欢迎联系我们以获得帮助。",
    ticketTransfer: "机票转让",
    ticketTransfer1: "您不能将机票转让给其他旅客。",
    ticketTransfer2: "如果您需要取消或重新预订机票，请注意：",
    ticketTransfer3: "大多数航空公司的机票都是不可退款的。",
    ticketTransfer4:
      "大多数航空公司都收取机票变更或取消费用。请查看您的行程单，了解详细信息。",
    ticketTransfer5:
      "如果机票上的姓名与政府签发的带本人照片的身份证件不符，请及早抵达机场并在航空公司柜台处出示姓名变更证明（例如结婚证或其他法律文件）。",
    mistakenMachine: "误机",
    mistakenMachineOperate: "如何操作",
    mistakenMachineOperate1:
      "如果您错过了航班，请直接联系航空公司以获得协助。某些航空公司可能会安排您搭乘下一趟合适的航班。",
    mistakenMachineOperate2:
      "因错过航班而申请的退款请求，需按照航空公司规定的手续费与限制条件进行处理。",
    mistakenMachineFriendshipHint:
      "如果航空公司变更或取消了您的航班，请参阅航空公司主动变更行程。",
    needOtherHelpContactUs: "如需其他帮助，请联系我们。",
    manageLowCostAirlineReservations: "管理低成本航空公司预订",
    manageLowCostAirlineReservations1:
      "如果您预订了低成本航空公司的机票，请直接联系航空公司，对预订进行变更、取消或管理。我们不能直接访问低成本航空公司的预订系统。",
    manageLowCostAirlineReservations2:
      "要管理此类预订，建议您从相应航空公司的网站入手。很多低成本航空公司提供各种自助服务功能，例如：",
    manageLowCostAirlineReservations3: "在线办理登机手续",
    manageLowCostAirlineReservations4: "选择座位",
    manageLowCostAirlineReservations5: "预订行李服务",
    payment: "付款",
    ticketPaymentMethod: "机票预订付款方式",
    onlinePaymentDetail:
      "您必须在预订机票时全额付款。您可以使用借记卡、信用卡、微信或支付宝在线付款。Trip 不接受订金或分期付款的方式。",
    onlinePaymentHints1: "不可分用 2 张或更多张信用卡进行付款。",
    onlinePaymentHints2:
      "在通过借记卡或信用卡进行大额付款之前，请联系相关银行或信用卡公司，确保未超过每日消费限额。",
    onlinePaymentHints3:
      "如果付款没有完成，请参阅如何处理付款被拒绝的情况，以了解详细信息及其他付款方法。",
    onlinePaymentHints4: "有关取消费用和退款信息，请阅读退款时限。",
    howToDealWithRejectionOfPayment: "如何处理付款被拒绝的情况",
    howToDealWithRejectionOfPayment1:
      "如果您的付款被拒绝，可能是由于以下某种原因：",
    howToDealWithRejectionOfPayment2:
      "您的卡超出了限额。请确认卡中有足够的额度（可以检查账户余额或者联系发卡机构），或者试试另一张卡。",
    howToDealWithRejectionOfPayment3:
      "输入的付款信息有错误，例如：帐单地址不正确或是信用卡到期日期有误。请核对您输入的信息，确保准确无误。",
    howToDealWithRejectionOfPayment4:
      "不支持您提供的付款方法。核实付款页面上的信息，确定是否接受您使用的付款方法。",
    howToDealWithRejectionOfPayment5:
      "由于出现技术问题，相关发卡机构无法授权您的交易。请联系您的发卡机构，或者再试一次。",
    howToDealWithRejectionOfPayment6:
      "发卡机构发现，有一笔付款不符合您的正常消费模式，阻止了该交易，以保护您的安全。请联系您的发卡机构，寻求帮助。",
    assistanceHelpContactUs: "如果您在付款方面需要协助，请联系我们。",
    refundTimeLimit: "退款时限",
    refundTimeLimitOperate: "如何运作",
    refundTimeLimitOperate1:
      "Trip 需要 24 小时时间处理您的退款。您的退款处理完毕后，相关金融机构可能最多需要 7 天的时间将款项转至您的账户，并且最多需要 2 个计帐周期才能在您的对帐单上列出该款项。",
    refundTimeLimitOperate2:
      "Trip 退款收据电子邮件中包含有关退款金额、退款方式以及退款完成时间的详细信息。",
    refundTimeLimitOperate3:
      "低成本航空公司机票退款由第三方（即相应的低成本航空公司）而非本公司处理。关于退款时限及相关问题，请咨询相关的第三方。",
    refundTimeLimitOperate4:
      "如果您符合退款条件并且同时使用积分和信用卡支付预订费用，您将收到退还的积分和信用卡退款。任何取消费用将优先从信用卡退款中扣除，然后如有需要，再从积分中扣除。",
    planeTicketDetail1:
      "对于某些机票订单，如您在 24 小时内取消预订，则可获得全额退款。",
    planeTicketDetail2: "有些机票则不可退款。",
    order: "订单",
    makeAReservation:
      "您可以访问Trip 网站或致电Trip 预订机票。",
    makeAReservationFollowing:
      "您可以在Trip 网站上预订以下类型的机票：",
    makeAReservationFollowing1: "往返机票，将回到始发机场。",
    makeAReservationFollowing2: "单程机票，从一地飞往另一地，不含回程。",
    makeAReservationFollowing3:
      "多个目的地的机票允许您在旅行期间游览多个目的地。",
    friendshipHintsDetail: "包机票价适用于往返机票或单程机票。",
    militaryAndBereavementFares: "军人票价和丧亲票价",
    militaryAndBereavementFaresDetail:
      "Trip 不会为军人或丧亲行提供机票折扣，但我们提供的票价特殊优惠可能比航空公司提供的军人或丧亲票价更低。请直接联系航空公司咨询军人或丧亲折扣票价，但请务必对比Trip Trip票价。",
    ticketBookingFee: "机票预订费用",
    ticketBookingFeeDetail:
      "针对包含 2 家不同航空公司的往返机票订单， Trip 会对每位乘客收取 USD7 的费用。例如：您为 2 位旅客预订了往返机票，去程搭乘达美航空航班，回程搭乘联合航空，则预订费总计为 USD14。",
    followingBookingIsNotCharged: "以下预订不收费：",
    followingBookingIsNotCharged1: "作为度假套餐一部分预订的机票。",
    followingBookingIsNotCharged2: "旅行的各个航段均选择同一家航空公司的航班。",
    passengersBookedAfterBookingAirTickets: "订完机票后添加旅客",
    operationProcess: "操作流程",
    passengerOperationProcess1: "您无法在既有机票订单中添加旅客。",
    passengerOperationProcess2: "如需添加同行的旅客，您需要重新预订航班。",
    passengerOperationProcess3:
      "对于新预订，Trip 不保证其价格与初始预订相同。",
    childrenAlone: "儿童独自乘机",
    childrenAloneDetail:
      "许多航空公司欢迎儿童在无成人陪伴的情况下乘坐其航班。但是，Trip 不会为年龄不满 18 岁、独自旅行的儿童预订机票。",
    childrenAloneHints1: "许多航空公司可能会对独自旅行的未成年人收取服务费。",
    childrenAloneHints2:
      "年龄不满 5 岁的儿童以及年满 17 岁的未成年人可能无法享受儿童独自旅行服务。",
    childrenAloneHints3:
      "您需要提前向航空公司提供在最终目的地迎接儿童的成人的详细联系信息。",
    childrenAloneHints4:
      "在机场送儿童登机的成人和在最终目的地迎接儿童的成人都必须出示身份证。",
    childrenAloneHints5:
      "如果您的往返机票由两个单程航班组成，请仔细查阅每家航空公司的相关规定。",
    contactAirlineAdviceOpportunityMinorsTravelAlone:
      "请联系航空公司咨询有关未成年人独自乘机的政策。",
    airTicketsForMultipleDestinations: "预订多个目的地的机票",
    operationSteps: "操作步骤",
    multipleTicketsOperationSteps1: "转到Trip 机票页面。",
    multipleTicketsOperationSteps2: "在搜索表单中选择多个目的地。",
    multipleTicketsOperationSteps3: "输入您的旅行目的地和日期，然后选择搜索。",
    bookingHints1: "预订前，请先登录账户。",
    bookingHints2: "您的整个行程将保存为一个行程单。",
    takePetOpportunity: "携带宠物乘机",
    travelRequirements: "旅行要求",
    takePetOpportunityDetail:
      "如果您要携带宠物旅行，请联系航空公司进行预订。航空公司可能要求您的宠物满足以下要求：",
    takePetOpportunityDetail1: "佩戴标有宠物名称和宠物许可证号的项圈",
    takePetOpportunityDetail2:
      "由兽医出具的健康状况良好的最新证明（不超过 30 天）",
    takePetOpportunityDetail3: "狂犬病接种证明（如果跨国旅行）",
    takePetOpportunityDetail4: "大小和数量限制",
    takePetOpportunityDetail5:
      "航空公司会限制允许携带进入舱房的宠物的数量和大小。通常，您可以携带小型宠物；只要用于装运它们的笼子可放在您前面座位的下方即可。",
    takePetOpportunityDetail6:
      "航空公司会限制在货舱中托运的动物的数量，具体视飞机和天气情况而定。",
    takePetOpportunityDetail7:
      "如果您的往返机票由两个单程航班组成，请仔细查阅每家航空公司的相关规定。",
    takePetOpportunityDetail8: "额外费用",
    takePetOpportunityDetail9:
      "如果需要携宠物进舱房或者在货舱托运宠物，大多数航空公司都会收取相关费用。",
    takePetOpportunityDetail10: "请联系航空公司，了解具体的宠物相关规定。",
    takeChildrenByChance: "带儿童乘机",
    ticketRequirementsForChildren: "儿童的机票要求",
    takeChildNotNeedTickets: "在以下情况下，您无需为儿童订票：",
    takeChildNotNeedTickets1: "您预订国内航班。",
    takeChildNotNeedTickets2: "儿童在航班起飞时未满 2 周岁。",
    takeChildNotNeedTickets3:
      "婴儿乘坐在另一位满足最低年龄要求的旅客的膝上。请致电航空公司了解详情。",
    takeChildNotNeedTickets4: "该旅客腿上只能坐 1 名幼儿。",
    takeChildMustTickets: "在以下情况下，您必须为儿童订票：",
    takeChildMustTickets1: "您预订国际航班。",
    takeChildMustTickets2: "儿童在航班起飞时已满 2 周岁。",
    takeChildMustTickets3: "儿童需要坐在自己的座位上。",
    ticketRequirementsForChildrenDetail:
      "航空公司的政策规定，一位符合航空公司所要求的最低年龄的乘客最多可携 2 名婴儿，但婴儿需分别坐在各自的位子上。",
    discountForChildrenFares: "儿童票价折扣",
    discountForChildrenFaresDetail1:
      "部分航空公司提供儿童票价折扣。票价是否提供折扣取决于您所选的航班、座位的供应情况以及旅客的年龄。",
    discountForChildrenFaresDetail2:
      "要查看所有适用的折扣，请确保在您搜索航班时选择同行儿童的人数和年龄。折扣票价已包含在您的搜索结果中，虽然可能不会标记为折扣票价。",
    documentationRequirementsChildren: "儿童的文件要求",
    documentationRequirementsChildren1:
      "对于国内航班，您可能需要为儿童提供带照片的身份证。",
    documentationRequirementsChildren2:
      "对于国际航班，您必须为所有年龄段的儿童提供有效护照。",
    documentationRequirementsChildren3:
      "父母均无陪同的儿童可能需要提供公证文件和授权书方可入境其他国家/地区。请向您目的地的大使馆或领事馆确认您的具体文件要求。",
    vehicleUseChildSafetySeats: "儿童安全座椅",
    vehicleUseChildSafetySeatsDetail:
      "部分航空公司要求凭自己的机票乘机的儿童坐在安装并卡在飞机座位上的儿童安全座椅中。",
    babyCarriage: "婴儿车",
    babyCarriageDetail:
      "在通过机场安检时，请折叠起婴儿车并将其连同您的其他物品一起穿过安检扫描设备。如果您选择托运婴儿车，许多航空公司将免费为您托运。",
    stillNeedHelp: "仍然需要帮助？",
    stillNeedHelpChild: "请联系航空公司咨询有关儿童乘机的政策。",
    other: "其他",
    accountSetting: "账户设置",
    changeEmailAndPassword: "变更电子邮件和密码",
    changeEmailAndPasswordOpera: "如需变更邮箱和密码，请执行以下操作：",
    changeEmailAndPasswordOpera1: "在个人信息页面上，选择电子邮件和密码。",
    changeEmailAndPasswordOpera2: "按照指示输入您的信息。",
    changeEmailAndPasswordOpera3: "分别选择保存以更新您的电子邮件和密码。",
    manageYourAccount: "管理您的Trip账户",
    manageYourAccountDetail:
      "通过Trip账户，您可以查看行程、改签和退票",

    createAnAccountFollowing: "如需创建账户，请执行以下操作：",
    createAnAccountFollowingDetail:
      "前往创建您的免费账户，并选择使用您的 Facebook 、微信、谷歌账户、邮箱或手机号码注册账户。",
    manageAnAccountFollowing: "如需管理账户，请执行以下操作：",
    manageAnAccountFollowing1: "前往个人中心。",
    manageAnAccountFollowing2: "选择常旅客管理以设置个人信息。",
    manageAnAccountFollowing3: "选择支付管理以更新您的付款详细信息。",
    manageAnAccountFollowing4: "选择优惠券以查看和兑换您的优惠券。",
    addNewPassengersAccountFollowing: "如需账户添加新旅客，请执行以下操作：",
    addNewPassengersAccountFollowing1: "前往个人中心。",
    addNewPassengersAccountFollowing2: "选择常旅客管理。",
    addNewPassengersAccountFollowing3: "选择 +添加常旅客信息。",
    addNewPassengersAccountFollowing4: "按照指示添加旅客的个人信息。",
    addNewPassengersAccountFollowing5: "选择保存。",
    closeYourAccountContactUs: "如果您希望关闭账户，请联系我们。",
    sitesOnMobileDevices: "在移动设备上访问Trip网站",
    sitesOnMobileDevicesDetail:
      "如需在移动设备上访问Trip网站，可直接在浏览器中输入 https://trip.ndccloud.com/。",
    mobileWebHints: "移动 Web 上提供的服务可能因设备而异。",
    associatedWithYourOtherAccounts:
      "关联您的Trip和 Facebook 、微信、谷歌账户",
    associatedWithYourOtherAccountsDetail:
      "将Trip账户与 Facebook 账户进行关联，可确保在登录 Facebook、微信、谷歌后即会登录Trip这样您就无需记住多个密码。",
    stepsAssociatedWithAccounts: "关联账户的步骤",
    stepsAssociatedWithAccounts1:
      "在登录页面上，选择登录 Facebook、微信或谷歌。",
    stepsAssociatedWithAccounts2:
      "系统出现提示时，输入与您的 Facebook 账户关联的电子邮件地址。",
    stepsAssociatedWithAccounts3:
      "如果该电子邮件地址未与您的Trip帐户相关联，请遵循相关说明关联您的账户。",
    associatedAccountsHints1:
      "关联账户不会为您订阅Trip的 Facebook、谷歌动态消息。",
    associatedAccountsHints2:
      "Trip不会在未得到您许可的情况下，在您的 Facebook 、谷歌账户上发布信息。",
    associatedAccountsHints3:
      "Trip仍会将您的行程信息发送到与Trip账户关联的电子邮件地址。",
    associatedAccountsHints4:
      "要查看关联的账户，请转到我的账户并选择账号绑定。",
    updatePassportInformation: "更新账户中的护照信息",
    updatePassportInformationDetail:
      "您可以为自己或其他旅客添加、变更或删除存储在Trip账户中的护照信息。",
    updatePassportInformationOpera: "如需访问护照信息，请执行以下操作：",
    updatePassportInformationOpera1: "登录账户。",
    updatePassportInformationOpera2: "转至个人中心。",
    addNewPassport: "如需添加新护照，请执行以下操作：",
    addNewPassport1: "选择护照。",
    addNewPassport2: "输入签发护照的国家/地区。",
    addNewPassport3: "输入护照号码。",
    addNewPassport4: "选择保存。",
    changeYourPassportNumber: "如需更改护照号码，请执行以下操作：",
    changeYourPassportNumber1: "在护照下，选择要变更的护照对应的编辑。",
    changeYourPassportNumber2: "变更现有的护照号码。",
    changeYourPassportNumber3: "选择保存。",
    deleteYourPassport: "如需删除护照，请执行以下操作：",
    deleteYourPassport1: "在护照下，选择要删除的护照对应的编辑。",
    deleteYourPassport2: "选择删除。",
    deleteYourPassport3: "出现提示时，选择是，确认删除护照。",
    passportHints:
      "您可以转到常旅客管理，选择其他旅客并执行上述相同步骤，对已保存的旅客护照信息进行修改。",
    travelDocuments: "旅行证件",
    customsRequirements: "海关要求",
    customsRequirementsDetail:
      "到其他国家/地区旅行时，请准备好以下证件，以便向海关工作人员出示：",
    customsRequirementsDetail1:
      "公民身份证明，例如有效护照或政府发放的带照片并且盖有钢印的身份证件和出生证明。",
    customsRequirementsDetail2: "旅行签证（如果要游览的国家/地区有此要求）。",
    customsRequirementsDetail3: "空乘人员或游轮员工提供的海关申报表。",
    internationalTravelDocument: "国际旅行证件",
    internationalTravelDocumentDetail:
      "如果您要跨国旅行，则需要准备好旅行证件，例如护照、旅行签证、ETA 或 ESTA。如果您没有准备好所需的证件，许多国家或地区都会拒绝您入境。为帮助您避免缴纳紧急预订费，并在旅行前提前准备好旅行证件。",
    passportDetail:
      "护照是政府签发的形似银行存折的身份证件（适用于所有国际旅行）或护照卡（仅适用于美国、加拿大、墨西哥、加勒比海和百慕大地区范围内的海陆旅行）。",
    visa: "签证",
    visaDetail:
      "旅行签证授权旅客进入和离开特定国家或地区。您可能需要为行程中的各个港口或中转站分别办理签证，因此请提前核实。",
    ESTAdetal: "ESTA（旅行许可电子系统）是非美国公民进入美国时必须办理的证件。",
    ETAaustralia: "澳大利亚或加拿大旅行所需的 ETA",
    ETAaustraliaDetail:
      "ETA（电子旅行签证）是非澳大利亚公民前往澳大利亚或非加拿大公民免签前往加拿大必须办理的证件。获得批准后，该证件将与您的护照相关联；因此无需携带额外的证件。您可以在澳大利亚电子旅行签证或加拿大电子旅行签证网站上找到相关申请及详细信息。",
    minorsTravelToSouthAfrica: "未成年人前往南非旅行",
    minorsTravelToSouthAfricaDetail:
      "对于前往南非进行国际旅行的所有未成年人，南非要求除提供护照外，还需提供出生证明。有关详细信息，请查看南非有关携带儿童出行的规定。",
    privacyAndSecurity: "隐私与安全",
    bewareOfEmailFraud: "谨防电子邮件诈骗",
    bewareOfEmailFraud1:
      "网络钓鱼是一种诈骗行为，通过以下方式实施：犯罪分子发送电子邮件索取个人信息，并企图诱骗收件人做出点击链接、打开附件等反应或直接提供敏感信息。",
    bewareOfEmailFraud2:
      "这些电子邮件貌似由知名的企业或组织发出，而且有时还附带链接来指向貌似合法的网站，因此极易让人信以为真。但是，您提供的信息（如身份证号或信用卡号）会直接转到犯罪分子手中，然后他们会利用这些信息为自己牟利。",
    countermeasures: "应对措施",
    countermeasuresDetail:
      "Trip绝不会打电话或发送电子邮件，询问您的密码或其他个人信息。如果您认为自己收到了欺诈性电子邮件：",
    countermeasuresDetail1: "切勿点击邮件中的任何链接或打开任何附件。",
    countermeasuresDetail2:
      "将整个电子邮件转发至reynold.zhang@5u6o7se0.dingmail.work 或联系我们。",
    countermeasuresDetail3: "删除该电子邮件。",
    pleaseReadOurPrivacyPolicy:
      "请阅读我们的隐私政策，详细了解我们如何保护您的信息。",
    watchOutForTelephoneFraud: "警惕电话诈骗",
    watchOutForTelephoneFraudDetail:
      "您是否收到过自动打来的电话，声称您中了Trip或其他知名旅游公司提供的某项大奖？这就是电话诈骗。一定要挂断电话，不要告诉来电者任何信息。",
    whatIsIt: "这是什么？",
    whatIsIt1: "骗子们惯用一些“哄骗”的手段，使他们的来电号码貌似来自本地。",
    whatIsIt2:
      "电话一开始通常是段预先录制好的语音留言，自称是Trip或其他知名旅游公司并告诉接听者“赢得”了某种大奖或旅游服务折扣。这些大奖可能包括现金卡、免费旅游或旅游积分，当然都是假的。",
    whatIsIt3:
      "由于来电者会想方设法隐藏自己的身份，或者假装自己代表某家知名企业或机构，所以这种电话听上去可能相当可信。但是，您提供的姓名、地址、付款信息、身份证号等信息会直接落到罪犯手中，他们可能会利用这些信息实施犯罪。",
    countermeasuresPhone1:
      "Trip绝不会打电话或发送电子邮件，询问您的密码或其他个人信息。如果您认为自己接到了欺诈性电话：",
    countermeasuresPhone2:
      "挂断电话。不要与来电者交谈。记下显示的号码（如果有的话）以及来电者提供的其他有助于辨别身份的信息。",
    countermeasuresPhone3: "将诈骗电话的相关信息发送至reynold.zhang@5u6o7se0.dingmail.work",
    paymentSecurityOptions: "付款安全和选项",
    paymentSecurityOptions1:
      "Trip账户可保护您的个人信息，并可为您保存付款信息，用于将来预订旅行。",
    paymentSecurityOptions2:
      "Trip采用最高的数字信息安全标准 - SSL，保护您的个人信息。只需核对浏览器中的地址是否以 https:// 开头，就能确认这一点。",
    paymentSecurityOptionsOpera: "如需将信用卡保存至账户，请执行以下操作：",
    paymentSecurityOptionsOpera1: "登录个人中心。",
    paymentSecurityOptionsOpera2: "选择支付管理。",
    paymentSecurityOptionsOpera3: "填写必填字段，然后选择保存。",
    paymentSecurityOptionsOpera4:
      "为了防止您的卡未经授权被使用，我们每次消费交易都会验证其 3 或 4 位安全码。此安全码位于大多数卡的签名栏中；如果是美国运通卡，则位于信用卡卡号上方。",
    paymentSecurityOptionsHints1:
      "如果付款没有完成，请参阅如何处理付款被拒绝的情况，以了解详细信息及其他付款方法。",
    paymentSecurityOptionsHints2:
      "除非另有说明，否则Trip网站上的所有价格均以欧元 (EUR, €) 报价。",
    protectingYourPersonalInformation:
      "Trip十分注重保护您的个人信息。有关详细信息，请查阅我们的隐私政策。",
    disclosingWebsiteVulnerabilities: "负责披露Trip网站漏洞",
    disclosingWebsiteVulnerabilities1:
      "Trip及其附属公司鼓励客户报告在我们的任何互联网站点上发现的漏洞。如果您认为您在我们的任何站点上的 Web 应用程序代码中发现了漏洞，请向我们发送一封电子邮件，并提供以下信息：",
    disclosingWebsiteVulnerabilities2: "发现漏洞的日期和时间",
    disclosingWebsiteVulnerabilities3: "具体代码",
    disclosingWebsiteVulnerabilities4: "概念验证漏洞攻击信息",
    thankYouEnsureSafety:
      "我们非常感谢您愿意与我们共同努力确保 Trip 的安全。",

    issuedWithin5mins: "此航程由廉航提供，预计支付后5分钟内完成出票！",
    priceChangeFrequently: "航班价格变动频繁，请及时付款",
    paymentTimeLeft: "剩余付款时间",
    contactNumber: "联系电话",
    perPerson: "人",
    price: "票价",
    transferTo: "中转",
    checkCodeFailed: "校验编码失败，订单失效，请重新下单",

    selectState: "请选择县/省/市/自治区",
    enterBillingAddress: "请输入有效的帐单地址",
    enterCity: "请输入有效的城市",
    enterValidEmailAddress: "请输入有效的电子邮件地址",
    //enterFirstName:"请输入姓名",
    //enterLastName:"请输入姓氏",
    settingDefault: "设为默认",
    confirmDelete: "确认删除?",
    //selectCountryTerritoryCode:"请选择国家/地区编码",
    //selectCountryTerritory:"请选择国家/地区",
    modifying: "修改中",
    modifySuccessful: "修改成功",
    addIn: "添加中",
    addSuccessful: "添加成功",
    airlineA: "航空公司",
    //selectGender:"请选择性别",
    //selectDateOfBirth:"请选择生日",
    //selectNationality:"请选择国籍",
    //selectIDtype:"请选择证件类型",
    //enterIDnumbers:"请输入证件号码",
    //selectExpiryDateOfCredentials:"请选择证件有效日期",
    //selectCountryForIssuingDocuments:"请选择证件发行国家",
    selectTypeOfPassenger: "请选择旅客类型",
    selectCarrier: "请选择航空公司",
    enterAirlineCard: "请输入航司卡号",

    payFaild: "您的{tripTypeText}机票下单成功,但是在支付的時候失败了！",
    paying: "您的{tripTypeText}机票付款中",
    paySuccess: "您的{tripTypeText}机票付款成功!",
    aircraftType: "机型",

    RefundChangeRules: "退票/改签规则",
    nonRefundableNonChangeable: "不可改退",
    nonFree: "有条件改/退",
    forFree: "免费改/退",
    toBeDetermined: "暂不明确",
    typeOfChanging: "改签类型",
    typeOfRefund: "退票类型",
    adultTicket: "成人票",
    childrenTicket: "儿童票",
    infantTicket: "婴儿票",
    flightInformation: "航程信息",
    enterReasonsDetails: "请输入具体原因，限300字(非必须)",
    onwardItinerary: "去程信息",
    returnItinerary: "返程信息",
    hasClosed: "已关闭",
    payLCCFaild: "您的机票下单失败!",
    paymentFailed: "支付失败",
    payTimeOnly: "付款时间仅剩",
    changeTheRouteInformation: "改签航段信息",
    chooseTheReasonForRefund: "选择退票原因",
    chooseReasonsForChanging: "选择改签原因",
    chooseFlightNeedRefund: "选择退票航班",
    chooseFlightNeedRefundPle: "请选择退票航班",
    confirmRefundOrder: "确认退票订单",
    confirmRefund: "确认退票",
    refundUnderReview:
      "您的行程：{startAddress}-{endAddress}退票申请我们已经收到，正在审核中",
    changing: "正在改签",
    refundMethod: "退款方式",
    basedOnTheActualPaymentTimeOfTheBank:
      "如审核通过,我们预计将会在7个工作日内根据您的支付账户原路返回,请以银行实际到款时间为准",
    enterYourAccount: "请输入您的收款银行卡号",
    involuntaryRefund: "因航空公司原因退票，请选择",
    flightDelayOrCancellationOrTimeChange: "航班延误或取消、航班时刻变更",
    involuntaryChange: "因航空公司原因改签，请选择",
    chooseToChangeTheOnwardFlight: "选择改签航班",
    chooseToChangeTheFlightPle: "请选择改签航班",
    chooseToChangeFlightInformation: "选择改签航班信息",
    chooseToChangeTheFlight: "选择改签航班",
    ticketing: "出票中",
    confirmTheChangeOfTheSegment: "确认改签航段",
    grounding: "停飞",
    ticketA: "票",
    original_price: "原价：",
    changeHasBeenSuccessfullySubmitted: "您的{tripTypeText}机票改签已成功提交",
    changingPleasePatient: "目前正在改签中，请您耐心等待",
    selectLeastOneTicketOperate: "请至少选择一张票进行操作",

    startAndEndDateOrderSearchCriteria:
      "请您输入订单创建的起止日期做为搜索条件",
    orderDetailsNotFound: "暂未找到订单详细信息，请稍后",
    noRefundDetailsFound: "暂未找到退票详细信息，请稍后",
    queryRefundInformationBusy: "查询退票信息正忙，请稍后",
    logInWithPhoneJustRegistered: "请用您刚注册的手机号登录",
    isAltering:
      "您的票已经有待改签航程信息，如您需要重新选择请先删除选择的航程！",
    licenseNumber: "牌照号码：352898",
    aboutUs: "关于我们",
    companyProfile: "公司简介",
    loginNow: "预定前先登入，可赚取积分",
    memberLogin: "会员登入",
    selectFlight: "选择飞往",
    goFlight: "的去程航班",
    returnFlight: "的返程航班",
    enterOldPassword: "请输入原密码",
    oldPasswordNew: "输入原密码",
    enterNewPasswordNew: "请输入新密码",
    newPasswordAgain: "请再次输入新密码",
    leftNum1: "剩余",
    leftNum2: "个座位",
    reimburse: "报销凭证",
    selectReimburse: "选择报销凭证服务",
    reimburseEmail: "报销凭证会在7个工作日内发送至您的主要联系人邮箱",
    cabinIsNotavilable1: "很抱歉，您选择的舱位不足",
    cabinIsNotavilable2: "人，请重新查询预订！",
    personalOrCompany: "个人/企业",
    passwordWrong: "账号不存在或密码错误",
    EnterPassWordAgainPlace: "再次输入密码",
    searchAgian: "重新搜索",
    noOrdertoAlter: "对不起，您暂时没有可改签的机票",
    reimburseTitle: "抬头",
    enterReimburseTitle: "请输入抬头",
    passportNum: "护照号码",
    createPassword: "建立密码",
    passwordFormatError: "密码格式错误",
    initFromCity: "香港/HKG-HK",
    insurance: "保险",
    insuranceOrder: "保险订单",
    insuranceOrderStatus: "保单状态",
    searchInsuranceOrder: "寻找保单",
    insuranceOrderNum: "保单号",
    insurancePriceTotal: "保单总额",
    insuranceSourcePrice: "原价",
    insurancePriceOff: "折",
    insurancePerson: "受保人",
    zurichOne_1: "·「苏黎世自游易保险计划」为您的海外旅行提供全方位保护，每位",
    zurichOne_6: "",
    zurichOne_2: "，为期",
    zurichOne_3: "天",
    zurichOne_4: "。有关此保障详情，",
    zurichOne_5: "请点击此处。",
    zurichTwo: "· 苏黎世保险有限公司为此旅游保险单之承保人",
    zurichThree: "· 香港五洲国际有限公司为苏黎世保险有限公司委託之保险代理",
    zurichFour_1:
      "为此行程所有旅客安排「苏黎世自游易保险计划」 (我已阅读、明白及同意遵守此之",
    zurichFour_2: "声明",
    zurichFour_3: "个人资料（隐私）条例",
    zurichFour_4: "及",
    zurichFour_5: "保单条款及细则",
    zurichFour_6:
      "。所有旅客均由香港出发并于旅程完结时返回香港，而此次旅程只属悠闲旅游或不涉及任何体力劳动的商务旅游。)",
    valueAddedServices: "保险",
    travelInsurance: "保险详情",
    insuranceAndEase: "一份保险 多份安心",
    nobuyThanks: "不购买，谢谢",
    zurichCheck:
      "好，我要为此行程所有旅客安排「苏黎世自游易保险计划」 (我已阅读、明白及同意遵守此之",
    zurichServer_1: "· 旅程取消、旅程延误",
    zurichServer_2: "· 24小时全球紧急支援服务",
    zurichServer_3: "· 保障一般旅游活动",
    insurancePrice: "保费",
    passengerInformation: "乘客信息",
    enterName: "请输入名字",
    emergencyContact: "紧急联系人",
    contactInformation: "联系人信息",
    clearFilter: "清除全部",
    loadingMore: "更多航班信息加载中",
    title: "Trip-廉价航空|特价机票查询|机票预订",
    getPrice: "获取价格",
    recommendationsforyou: "为您推荐",
    frequentFlyerNumberOptional: "常旅客号码（选填）",
    frequentFlyerProgram: "常旅客计划",
    frequentFlyerNumber: "常旅客号码",
    frequentFlyerNumberPlease: "请填写常旅客号码",
    frequentFlyerMsg:
      "如果您的登记人信息已与里程卡相连，航空公司会自动为您累积飞行里程。",
    pullDownLoadMore: "下拉加载更多航班信息",
    carryonBaggage: "手提行李",
    oldPasswordError: "旧密码错误",
    passwordModificationFailed: "密码修改失败",
    localTime: "当地时间",
    hongKongDollar: "港币",
    newTaiwanDollar: "新台币",
    usdDollar: "美元",
    eurDollar: "欧元",
    cnyDollar: '人民币',
    chooseArenewalApplicant: "选择改签申请人",
    moreSegments: "更多航段",
    refundRequestSuccess: "您的退票申请已成功提交",
    refundingPleasePatient: "目前正在审核中，请您耐心等待",
    noMatchingData: "无匹配数据",
    popularCities: "热门城市",
    refunding: "正在退票",
    clickToView: "点击查看",
    NotAllowedSameNum: "不允许输入相同的证件号",
    VJVZreadAndAgree: "已阅读并同意 ",
    VJAgree: "越捷航空条款和条件",
    VZAgree: "泰国越捷航空条款和条件",
    passportRepeated: "护照号码重复",
    additionalServices: "附加服务",
    seatSelection: "选座",
    seatServices: "选座服务",
    allFlights: "全部航程",
    pleaseSelectSeat: "请选择座位",
    seatRemark: "备注，限100字（非必须）",
    seatNote1:
      "1、在航班起飞前，您可以足不出户，根据自己的喜好事先在网上选择座位，并于航空公司柜台办理乘机",
    seatNote2:
      "2、通过网络提前预订航班座位，让您从容、便捷、一步到位地享受从订票到选座的便捷高效服务",
    seatNote3:
      "3、由于航司和航线的规则不同，无法确保100%选座成功，若您所购买的选座服务未处理成功，系统将会自动全额退款",
    ageDateCalc: "注意：年龄计算都以实际航班最后起飞日期为准。",
    passengerTypeError: "乘客类型错误，请重新填写",
    aboutDescTitle: "让我们带您Trip！",
    aboutDescText:
      "为满足市场需求，我们不断创新旅游产品，挖掘低价，培训员工提升服务。经过不懈的努力，近几年与全球三大旅游科技公司达成战略合作伙伴，提供全球超过500家航空公司数据；同时，不断拓展境外当地合作伙伴，获取最优资源，业务网络覆盖全球40多个国家和地区，去年全年销售总额达到35亿，仍在不断增长。",

    baggageAllowance: "行李额",
    selectBaggage: "添加行李",
    baggageSelection: "选择行李额",
    baggagePiece: "件",
  }
};



//////////////////
// WEBPACK FOOTER
// ./static/lang/homePage/zhCHS.js
// module id = HaSt
// module chunks = 34